var _ellipse, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g2, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g3, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g4, _path61, _path62, _g5, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g6, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptyRecord = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 273,
  height: 200,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 44,
  y: 0,
  width: 201,
  height: 200
}, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 144.651,
  cy: 100,
  rx: 100.231,
  ry: 100,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M294.996-.612h-444.357v97.955h444.357V-.612Z",
  fill: "#F1F8FF"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  fill: "#A7D887"
}, /*#__PURE__*/React.createElement("path", {
  d: "M166.589 89.201h-2.696V97.2h2.696V89.2ZM163.252 85.35h-2.371V97.2h2.371V85.35Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.699 90.372h-4.554V97.2h4.554v-6.828Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.737 92.806h-2.673V97.2h2.673v-4.394ZM159.318 87.588h-1.777V97.2h1.777v-9.612ZM156.423 81.887h-3.96V97.2h3.96V81.887ZM150.641 76.082h-2.368V97.2h2.368V76.082ZM147.765 80.494h-2.886V97.2h2.886V80.494Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.146 91.296h-4.214V97.2h4.214v-5.903ZM152.128 86.723h-2.323V97.2h2.323V86.723Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.965 93.894h-1.695v3.305h1.695v-3.305ZM167.438 93.894h-1.696v3.305h1.696v-3.305ZM150.641 90.589h-3.381v6.61h3.381v-6.61ZM145.247 88.35h-7.493v8.85h7.493v-8.85ZM123.859 93.885h-7.494V97.2h7.494v-3.315ZM137.752 93.449h-1.371v3.75h1.371v-3.75Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.067 87.475h-4.889v9.724h4.889v-9.724Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.001 83.647h-2.708v13.552h2.708V83.647Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.445 91.105h-3.656V97.2h3.656v-6.095Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.705 86.522h-2.101V97.2h2.101V86.522Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.062 83.423h-5.027V97.2h5.027V83.423ZM143.966 78.968h-1.554V97.2h1.554V78.97ZM139.623 91.33h-1.299v5.87h1.299v-5.87Z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  fill: "#A7D887"
}, /*#__PURE__*/React.createElement("path", {
  d: "M186.567 89.201h-2.696V97.2h2.696V89.2ZM183.229 85.351h-2.372V97.2h2.372V85.351Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.678 90.373h-4.555V97.2h4.555v-6.827Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.714 92.806h-2.673V97.2h2.673v-4.394ZM179.295 87.589h-1.777V97.2h1.777V87.59ZM176.399 81.887h-3.96V97.2h3.96V81.887ZM170.618 67.515h-2.368V97.2h2.368V67.515ZM167.742 71.436h-2.887V97.2h2.887V71.436Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.123 91.297h-4.215V97.2h4.215v-5.903ZM172.105 86.724h-2.324V97.2h2.324V86.724Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.942 93.895h-1.696V97.2h1.696v-3.305ZM187.415 93.895h-1.696V97.2h1.696v-3.305ZM170.618 90.59h-3.382v6.61h3.382v-6.61ZM165.222 88.35h-7.493v8.85h7.493v-8.85ZM143.836 88.35h-7.494v8.85h7.494v-8.85ZM157.728 93.45h-1.371v3.75h1.371v-3.75Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.044 87.476h-4.89V97.2h4.89v-9.724Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.976 82.567h-1.554V97.2h1.554V82.567ZM151.421 91.106h-3.655V97.2h3.655v-6.094Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.68 86.523h-2.102V97.2h2.102V86.523Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.036 83.423h-5.026V97.2h5.026V83.423ZM163.942 78.969h-1.553V97.2h1.553V78.969ZM159.598 91.33h-1.299v5.87h1.299v-5.87Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M123.4 92.04h-3.334v5.16h3.334v-5.16ZM127.127 89.557h-2.932V97.2h2.932v-7.644Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.505 92.796h-5.632V97.2h5.632v-4.404Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.661 94.366h-3.306V97.2h3.306v-2.835ZM131.254 91h-2.197v6.2h2.197V91ZM137.535 87.322h-4.896V97.2h4.896v-9.878ZM142.713 85.046h-2.928V97.2h2.928V85.046ZM146.908 87.894h-3.568v9.307h3.568v-9.307Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.718 93.392h-5.21V97.2h5.21v-3.808ZM140.818 90.441h-2.873V97.2h2.873v-6.758Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.007 95.068h-2.097v2.133h2.097v-2.133ZM121.115 95.068h-2.097v2.133h2.097v-2.133ZM143.966 92.935h-4.181V97.2h4.181v-4.265ZM155.722 91.49h-9.265v5.71h9.265v-5.71ZM183.87 93.696h-10.972v3.505h10.972v-3.505Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.415 94.78h-1.694v2.42h1.694v-2.42Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.613 90.926h-6.045v6.273h6.045v-6.273Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.518 87.76h-1.92v9.44h1.92v-9.44ZM168.037 93.269h-4.519V97.2h4.519V93.27Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.506 90.313h-2.6V97.2h2.6v-6.888Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.156 88.314h-6.215V97.2h6.215v-8.887ZM149.958 87.253h-1.921V97.2h1.921v-9.947ZM155.016 93.414h-1.606V97.2h1.606v-3.787Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  fill: "#A7D887"
}, /*#__PURE__*/React.createElement("path", {
  d: "M161.615 87.78h-2.943v9.42h2.943v-9.42ZM164.906 83.245h-2.588v13.956h2.588V83.245Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.89 89.16h-4.972v8.04h4.972v-8.04Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.611 92.025h-2.918v5.176h2.918v-5.176ZM168.55 85.88h-1.941V97.2h1.941V85.88ZM174.094 71.436h-4.323V97.2h4.323V71.436ZM178.662 75.73h-2.584V97.2h2.584V75.73ZM182.369 77.526h-3.15V97.2h3.15V77.526Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.488 90.249h-4.599V97.2h4.599V90.25ZM176.992 84.862h-2.537V97.2h2.537V84.862Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.392 93.308h-1.851V97.2h1.851v-3.892ZM159.597 93.308h-1.851V97.2h1.851v-3.892ZM179.769 89.414h-3.691V97.2h3.691v-7.786ZM190.148 86.777h-8.179V97.2h8.179V86.777ZM213.49 95.513h-8.179V97.2h8.179v-1.688ZM191.647 92.784h-1.497V97.2h1.497v-4.417Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196.233 85.747h-5.337V97.2h5.337V85.747Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.292 81.609h-2.956V97.2h2.956V81.61Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.02 90.022h-3.991v7.177h3.991v-7.177Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.318 84.626h-2.295V97.2h2.295V84.626Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.403 89.898h-7.583V97.2h7.583v-7.302ZM185.062 75.728h-1.695V97.2h1.695V75.728ZM189.525 90.288h-1.418v6.913h1.418v-6.913Z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  fill: "#A7D887"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141.076 87.78h-2.734v9.42h2.734v-9.42ZM144.136 83.245h-2.406V97.2h2.406V83.245Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.907 89.159h-4.62v8.04h4.62v-8.04Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.932 92.025h-2.711v5.176h2.711v-5.176ZM147.517 85.88h-1.802V97.2h1.802V85.88ZM152.671 79.165h-4.017V97.2h4.017V79.165Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.918 71.436h-4.289V97.2h4.289V71.436ZM160.36 73.892h-2.926V97.2h2.926V73.892ZM151.18 90.248h-4.274V97.2h4.274v-6.952Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.366 84.862h-2.356V97.2h2.356V84.862Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.88 93.308h-1.72V97.2h1.72v-3.892ZM139.202 93.308h-1.72V97.2h1.72v-3.892ZM157.947 89.414h-3.429V97.2h3.429v-7.786ZM167.589 86.777h-7.599V97.2h7.599V86.777ZM189.278 86.777h-7.6V97.2h7.6V86.777ZM168.98 92.783h-1.39V97.2h1.39v-4.417Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.241 85.746h-4.958V97.2h4.958V85.746Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.981 79.967h-1.575V97.2h1.575V79.967ZM177.69 90.022h-3.708v7.177h3.708v-7.177Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.898 84.625h-2.132V97.2h2.132V84.625Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.529 80.975h-5.097v16.224h5.097V80.975ZM162.863 75.728h-1.576V97.2h1.576V75.728ZM167.009 90.288h-1.318V97.2h1.318v-6.912Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M205.784 91.122h-3.38V97.2h3.38v-6.078ZM201.596 88.197h-2.973V97.2h2.973v-9.003Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.907 92.012h-5.712V97.2h5.712v-5.188Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.461 93.86h-3.352v3.34h3.352v-3.34ZM196.666 89.897h-2.228V97.2h2.228v-7.303ZM193.033 85.565h-4.965V97.2h4.965V85.565ZM185.785 78.151h-2.969V97.2h2.969V78.15ZM182.179 86.238h-3.618v10.96h3.618v-10.96Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M195.196 92.715h-5.284v4.484h5.284v-4.484ZM187.648 89.24h-2.914v7.96h2.914v-7.96Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.7 94.688h-2.126v2.511h2.126v-2.511ZM206.847 94.688h-2.126v2.511h2.126v-2.511ZM185.787 92.176h-4.24V97.2h4.24v-5.023ZM179.021 90.475h-9.396V97.2h9.396v-6.725ZM152.203 93.073h-11.127V97.2h11.127v-4.127ZM169.621 94.35h-1.719v2.85h1.719v-2.85Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.765 89.81h-6.13v7.39h6.13v-7.39Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.665 86.082h-1.948V97.2h1.948V86.082Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.719 92.569h-4.584v4.63h4.584v-4.63Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.28 89.087h-2.635v8.112h2.635v-8.112Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.217 86.732h-6.303V97.2h6.303V86.732ZM177.417 85.485h-1.948v11.714h1.948V85.485ZM171.968 92.74h-1.628v4.46h1.628v-4.46Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.387 77.117h-7.813V96.75h7.813V77.117Z",
  fill: "#8CDEA4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.386 94.534h-3.306v.597h3.306v-.597Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.48 94.534h-1.16v.597h1.16v-.597Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.656 94.534h-2.082v.597h2.082v-.597ZM161.438 93.34h-1.358v.598h1.358v-.597ZM163.389 93.34h-1.358v.598h1.358v-.597ZM162.795 92.147H158.9v.597h3.895v-.597ZM158.289 92.147h-2.715v.597h2.715v-.597ZM163.386 90.954h-3.306v.597h3.306v-.597Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.482 90.954h-3.154v.597h3.154v-.597Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.105 89.761h-2.785v.596h2.785v-.596ZM157.506 89.761h-1.027v.596h1.027v-.596Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.795 88.567h-2.715v.597h2.715v-.597Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.481 88.567h-2.715v.597h2.715v-.597ZM157.675 87.374h-2.101v.597h2.101v-.597ZM160.759 87.374H158.9v.597h1.859v-.597ZM162.326 87.374h-.93v.597h.93v-.597ZM163.386 86.182h-3.306v.596h3.306v-.596Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.016 86.182h-2.715v.596h2.715v-.596Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.438 84.988h-1.358v.597h1.358v-.597ZM159.48 84.988h-1.16v.597h1.16v-.597ZM162.797 83.794h-1.358v.597h1.358v-.597ZM159.481 83.794h-2.715v.597h2.715v-.597ZM160.847 82.6H158.9v.598h1.947V82.6ZM157.506 82.6h-1.947v.598h1.947V82.6Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.795 81.408h-2.715v.597h2.715v-.597Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.481 81.408h-2.715v.597h2.715v-.597ZM161.072 80.214h-2.715v.597h2.715v-.597ZM162.795 79.021h-2.715v.597h2.715v-.597Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.348 79.021h-2.774v.597h2.774v-.597Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.388 77.828h-7.829v.597h7.829v-.597Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M163.387 96.75h-7.813l7.813-19.633V96.75Z",
  fill: "#1E292E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.972 85.38h-5.156v11.37h5.156V85.38Z",
  fill: "#8CDEA4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.972 95.467h-2.183v.346h2.183v-.346Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.394 95.467h-.765v.346h.765v-.346Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.188 95.467h-1.374v.346h1.374v-.346ZM186.685 94.777h-.896v.345h.896v-.345ZM187.97 94.777h-.896v.345h.896v-.345ZM187.58 94.085h-2.57v.345h2.57v-.345ZM184.607 94.085h-1.793v.345h1.793v-.345ZM187.972 93.394h-2.183v.346h2.183v-.346Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.392 93.394h-2.081v.346h2.081v-.346Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.466 92.704h-1.837v.345h1.837v-.345ZM184.09 92.704h-.678v.345h.678v-.345Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.581 92.012h-1.792v.345h1.792v-.345Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.394 92.012h-1.792v.345h1.792v-.345ZM184.202 91.321h-1.388v.346h1.388v-.346ZM186.236 91.321h-1.226v.346h1.226v-.346ZM187.269 91.321h-.613v.346h.613v-.346ZM187.972 90.63h-2.183v.346h2.183v-.346Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.085 90.63h-1.792v.346h1.792v-.346Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.685 89.939h-.896v.345h.896v-.346ZM185.394 89.939h-.765v.345h.765v-.346ZM187.582 89.248h-.896v.345h.896v-.345ZM185.394 89.248h-1.792v.345h1.792v-.345ZM186.295 88.557h-1.285v.345h1.285v-.345ZM184.09 88.557h-1.285v.345h1.285v-.345Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.581 87.866h-1.792v.346h1.792v-.346Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.394 87.866h-1.792v.346h1.792v-.346ZM186.443 87.175h-1.793v.345h1.793v-.345ZM187.581 86.483h-1.792v.345h1.792v-.345Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.646 86.483h-1.832v.345h1.832v-.345Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.972 85.793h-5.167v.345h5.167v-.345Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M187.972 96.75h-5.156l5.156-11.37v11.37Z",
  fill: "#1E292E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.409 84.216h-5.671V96.75h5.671V84.216Z",
  fill: "#8CDEA4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.407 95.335h-2.399v.381h2.399v-.38Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.574 95.335h-.842v.381h.842v-.38Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.247 95.335h-1.511v.381h1.511v-.38ZM165.993 94.573h-.985v.381h.985v-.38ZM167.41 94.573h-.986v.381h.986v-.38ZM166.981 93.811h-2.827v.381h2.827v-.38ZM163.707 93.811h-1.971v.381h1.971v-.38ZM167.407 93.05h-2.399v.38h2.399v-.38Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.574 93.05h-2.289v.38h2.289v-.38Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.754 92.288h-2.022v.381h2.022v-.38ZM163.14 92.288h-.745v.381h.745v-.38Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.979 91.526h-1.971v.381h1.971v-.38Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.574 91.526h-1.97v.381h1.97v-.38ZM163.261 90.764h-1.525v.381h1.525v-.38ZM165.503 90.764h-1.349v.381h1.349v-.38ZM166.638 90.764h-.675v.381h.675v-.38ZM167.407 90.002h-2.399v.381h2.399v-.38Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.234 90.002h-1.97v.381h1.97v-.38Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.993 89.24h-.985v.382h.985v-.381ZM164.574 89.24h-.842v.382h.842v-.381ZM166.98 88.479h-.986v.38h.986v-.38ZM164.574 88.479h-1.97v.38h1.97v-.38ZM165.567 87.716h-1.413v.381h1.413v-.38ZM163.14 87.716h-1.413v.381h1.413v-.38Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.979 86.955h-1.971v.38h1.971v-.38Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.574 86.955h-1.97v.38h1.97v-.38ZM165.729 86.193h-1.971v.38h1.971v-.38ZM166.979 85.431h-1.971v.381h1.971v-.38Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.75 85.431h-2.014v.381h2.014v-.38Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.409 84.669h-5.682v.38h5.682v-.38Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M167.409 96.75h-5.671l5.671-12.534V96.75Z",
  fill: "#1E292E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.221 79.997h-6.422V96.75h6.422V79.997Z",
  fill: "#8CDEA4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.22 81.378h-2.718v.51h2.718v-.51Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.01 81.378h-.953v.51h.953v-.51Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.51 81.378h-1.711v.51h1.711v-.51ZM182.617 82.397h-1.115v.51h1.115v-.51ZM184.22 82.397h-1.116v.51h1.116v-.51ZM183.735 83.415h-3.202v.51h3.202v-.51ZM180.031 83.415h-2.232v.51h2.232v-.51ZM184.22 84.433h-2.718v.509h2.718v-.509Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.009 84.433h-2.593v.509h2.593v-.509Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.345 85.452h-2.288v.508h2.288v-.508ZM179.387 85.452h-.844v.508h.844v-.508Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.733 86.47h-2.231v.51h2.231v-.51Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.01 86.47h-2.233v.51h2.233v-.51ZM179.527 87.489h-1.728v.509h1.728v-.51ZM182.061 87.489h-1.528v.509h1.528v-.51ZM183.348 87.489h-.764v.509h.764v-.51ZM184.22 88.506h-2.718v.51h2.718v-.51Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.624 88.506h-2.231v.51h2.231v-.51Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.617 89.525h-1.115v.509h1.115v-.51ZM181.01 89.525h-.953v.509h.953v-.51ZM183.735 90.543h-1.116v.51h1.116v-.51ZM181.01 90.543h-2.233v.51h2.233v-.51ZM182.134 91.561h-1.601v.509h1.601v-.509ZM179.386 91.561h-1.601v.509h1.601v-.509Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.733 92.58h-2.231v.508h2.231v-.508Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.01 92.58h-2.233v.508h2.233v-.508ZM182.315 93.598h-2.231v.509h2.231v-.509ZM183.733 94.616h-2.231v.51h2.231v-.51Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.08 94.616h-2.281v.51h2.281v-.51Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M184.221 96.75h-6.422l6.422-16.753V96.75Z",
  fill: "#1E292E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.59 72.567h-6.508V96.75h6.508V72.567Z",
  fill: "#8CDEA4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.59 94.02h-2.754v.735h2.754v-.735Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.337 94.02h-.966v.735h.966v-.735Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.817 94.02h-1.735v.735h1.735v-.735ZM173.967 92.55h-1.131v.736h1.131v-.736ZM175.59 92.55h-1.131v.736h1.131v-.736ZM175.1 91.08h-3.245v.736h3.245v-.735ZM171.344 91.08h-2.262v.736h2.262v-.735ZM175.59 89.61h-2.754v.736h2.754v-.735Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.337 89.61h-2.628v.736h2.628v-.735Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.691 88.142h-2.32v.735h2.32v-.735ZM170.689 88.142h-.855v.735h.855v-.735Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.098 86.67h-2.262v.736h2.262v-.735Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.336 86.67h-2.262v.736h2.262v-.735ZM170.833 85.201h-1.751v.735h1.751v-.735ZM173.403 85.201h-1.548v.735h1.548v-.735ZM174.706 85.201h-.774v.735h.774v-.735ZM175.59 83.732h-2.754v.735h2.754v-.735Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.947 83.732h-2.261v.735h2.261v-.735Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.967 82.262h-1.131v.735h1.131v-.735ZM172.337 82.262h-.966v.735h.966v-.735ZM175.098 80.792h-1.131v.735h1.131v-.735ZM172.336 80.792h-2.262v.735h2.262v-.735ZM173.477 79.322h-1.622v.735h1.622v-.735ZM170.691 79.322h-1.623v.735h1.623v-.735Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.098 77.853h-2.262v.735h2.262v-.735Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.336 77.853h-2.262v.735h2.262v-.735ZM173.662 76.382H171.4v.735h2.262v-.735ZM175.098 74.912h-2.262v.735h2.262v-.735Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.393 74.912h-2.311v.735h2.311v-.735Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.591 73.442h-6.523v.736h6.523v-.736Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M175.591 96.75h-6.509l6.509-24.183V96.75Z",
  fill: "#1E292E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.45 85.066h-4.479V96.75h4.479V85.066Z",
  fill: "#8CDEA4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.451 86.03h-1.896v.355h1.896v-.355Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.211 86.03h-.664v.355h.664v-.355Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.165 86.03h-1.194v.355h1.194v-.355ZM147.333 86.74h-.778v.355h.778v-.355ZM148.448 86.74h-.778v.355h.778v-.355ZM148.112 87.45h-2.233v.355h2.233v-.355ZM145.527 87.45h-1.556v.355h1.556v-.355ZM148.451 88.16h-1.896v.355h1.896v-.355Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.213 88.16h-1.809v.355h1.809v-.355Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.143 88.87h-1.596v.356h1.596v-.355ZM145.079 88.87h-.589v.356h.589v-.355Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.111 89.58h-1.556v.356h1.556v-.355Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.209 89.58h-1.557v.356h1.557v-.355ZM145.176 90.291h-1.205v.355h1.205v-.355ZM146.945 90.291h-1.066v.355h1.066v-.355ZM147.839 90.291h-.532v.355h.532v-.355ZM148.451 91.001h-1.896v.355h1.896v-.355Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.941 91.001h-1.556v.355h1.556v-.355Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.333 91.71h-.778v.356h.778v-.355ZM146.211 91.71h-.664v.356h.664v-.355ZM148.11 92.421h-.778v.355h.778v-.355ZM146.209 92.421h-1.557v.355h1.557v-.355ZM146.995 93.132h-1.116v.355h1.116v-.355ZM145.078 93.132h-1.117v.355h1.117v-.355Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.111 93.842h-1.556v.355h1.556v-.355Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.209 93.842h-1.557v.355h1.557v-.355ZM147.123 94.552h-1.557v.355h1.557v-.355ZM148.111 95.262h-1.556v.355h1.556v-.355Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.562 95.262h-1.591v.355h1.591v-.355Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M148.45 96.75h-4.479l4.479-11.685V96.75Z",
  fill: "#1E292E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.733 82.054H150.1v14.697h5.633V82.054Z",
  fill: "#8CDEA4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.734 95.09h-2.384v.448h2.384v-.447Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.916 95.09h-.836v.448h.836v-.447Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.601 95.09H150.1v.448h1.501v-.447ZM154.329 94.198h-.979v.447h.979v-.447ZM155.733 94.198h-.979v.447h.979v-.447ZM155.308 93.305H152.5v.446h2.808v-.446ZM152.058 93.305H150.1v.446h1.958v-.446ZM155.734 92.412h-2.384v.446h2.384v-.446Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.917 92.412h-2.274v.446h2.274v-.446Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.088 91.519h-2.008v.446h2.008v-.446ZM151.493 91.519h-.741v.446h.741v-.446Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.307 90.624h-1.957v.447h1.957v-.447Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.917 90.624h-1.958v.447h1.958v-.447ZM151.615 89.732H150.1v.447h1.515v-.447ZM153.84 89.732h-1.34v.447h1.34v-.447ZM154.967 89.732h-.67v.447h.67v-.447ZM155.734 88.838h-2.384v.447h2.384v-.447Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.58 88.838h-1.957v.447h1.957v-.447Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.329 87.945h-.979v.447h.979v-.447ZM152.916 87.945h-.836v.447h.836v-.447ZM155.307 87.053h-.979v.447h.979v-.447ZM152.917 87.053h-1.958v.447h1.958v-.447ZM153.904 86.16H152.5v.446h1.404v-.447ZM151.492 86.16h-1.404v.446h1.404v-.447Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.307 85.266h-1.957v.447h1.957v-.447Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.917 85.266h-1.958v.447h1.958v-.447ZM154.063 84.372h-1.958v.447h1.958v-.447ZM155.307 83.479h-1.957v.447h1.957v-.447Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.101 83.479H150.1v.447h2.001v-.447Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.733 82.586h-5.645v.447h5.645v-.447Z",
  fill: "#F1F2F7"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M155.733 96.75H150.1l5.633-14.696V96.75Z",
  fill: "#1E292E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M188.531 49.752c-.474.016-.935.022-1.39.025-.328 1.184-4.826 2.27-10.346 2.461-5.739.2-10.396-.641-10.406-1.879-.004-.709 1.523-1.393 3.906-1.887-2.339-.197-3.925-.678-3.93-1.294-.006-.902 3.378-1.75 7.561-1.895 3.398-.119 6.279.264 7.241.896 1.876-.469 4.466-.81 7.331-.909 5.739-.2 10.397.642 10.408 1.879.008 1.237-4.637 2.402-10.376 2.602h.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M177.679 39.165c.6.02 1.185.03 1.76.037.417 1.28 6.11 2.481 13.097 2.724 7.263.252 13.156-.625 13.168-1.96.004-.767-1.93-1.516-4.947-2.064 2.96-.197 4.966-.705 4.972-1.37.006-.974-4.277-1.912-9.572-2.096-4.3-.15-7.946.245-9.163.92-2.374-.518-5.654-.903-9.28-1.028-7.263-.253-13.158.625-13.169 1.96-.01 1.336 5.871 2.624 13.134 2.877Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M174.528 45.208c1.522 1.248 11.324 2.113 21.891 1.933 6.06-.103 11.042-.529 13.919-1.106 2.993.466 7.992.733 13.251.643 7.706-.131 13.055-.975 11.938-1.884-.893-.738-5.789-1.294-11.722-1.405 2.955-.467 4.405-1.067 3.65-1.69-1.525-1.248-11.326-2.112-21.893-1.933-10.567.18-17.909 1.338-16.388 2.586.125.103.328.201.557.299-9.923.243-16.665 1.359-15.204 2.558l.001-.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280.357 96.26 4.776 1.052H125.012l11.059-1.6 11.684-2.15 5.73-.827s5.058-.112 6.741.477c1.687.589 18.322-.383 18.322-.383s6.803-.931 8.068-1.05c1.265-.117 11.063-1.32 15.766-.954 4.701.363 9.647-.292 13.748.272 4.1.566 13.097-.353 16.015-.725 2.918-.372 17.138 1.309 18.579 1.63 1.444.32 6.925-1.589 9.958-.905 3.034.684 19.673 5.164 19.673 5.164h.002Z",
  fill: "#D7E8B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.379 95.084h-.33v1.2h.33v-1.2Z",
  fill: "#5C666E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M214.142 95.084h-.05v1.2h.05v-1.2Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M214.336 95.084h-.078v1.2h.078v-1.2Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m215.532 95.575-2.889.201-.026-.042 2.898-.558.054.293-.037.106Z",
  fill: "#131A1D"
}), /*#__PURE__*/React.createElement("path", {
  d: "m216.24 91.968-.066-.013-2.547 1.519-1.01 2.26 2.952-.265.671-3.501Z",
  fill: "#424D54"
}), /*#__PURE__*/React.createElement("path", {
  d: "m213.603 93.457 2.57-1.501-.166.852-2.681 1.271.277-.622Zm-.613 1.373 2.797-.893.211-1.083-2.686 1.258-.321.718h-.001Zm-.392.878 2.9-.29.277-1.421-2.802.87-.375.84Z",
  fill: "#E5E6EC"
}), /*#__PURE__*/React.createElement("path", {
  d: "m215.644 92.434-.038.006.032-.129.046-.042.331-.191.043-.01-.028.134-.051.045-.335.187Zm-.062.02.034-.129-.037.007-.29.168-.042.038-.037.125.033-.004.294-.164.046-.04-.001-.001Zm-.393.22.037-.125-.031.005-.257.149-.038.035-.039.12.027-.002.26-.145.042-.037h-.001Zm-.348.195.04-.12-.027.002-.229.133-.035.033-.042.116h.023l.232-.13.038-.035Zm-.31.174.041-.117-.023.002-.206.12-.032.03-.043.112h.021l.207-.115.035-.032Zm-.278.155.044-.113h-.02l-.186.108-.03.028-.044.11h.017l.187-.104.032-.03Zm-.25.14.044-.108h-.018l-.169.096-.027.027-.045.105.016.002.17-.094.029-.028Zm-.228.128.045-.105-.015-.002-.154.09-.026.025-.045.102.013.003.154-.086.027-.026.001-.001Zm2.164-1.031.052-.045.029-.14-.044.008-.335.187-.047.041-.034.136.038-.005.341-.182Zm-.749.399.299-.16.047-.04.034-.135-.037.005-.294.163-.042.038-.038.13.032-.002h-.001Zm-.345.066-.041.126h.027l.263-.141.042-.037.039-.13-.031.003-.26.145-.039.034Zm-.312.173-.043.121h.024l.234-.124.038-.035.042-.125-.027.002-.232.129-.035.032h-.001Zm-.28.156-.045.117.021.001.209-.111.035-.032.043-.12h-.023l-.208.115-.032.03Zm-.252.14-.046.112.018.002.188-.1.032-.03.044-.116h-.02l-.187.103-.03.028h.001Zm-.228.126-.046.109.016.003.17-.091.03-.028.045-.113-.017-.001-.17.095-.028.026Zm-.182.09-.026.026-.047.105.014.003.154-.082.027-.026.047-.109-.016-.002-.154.086h.001Zm2.307-.954.053-.046.03-.147-.044.007-.341.182-.048.041-.035.141.038-.002.347-.177Zm-.411.191.037-.141-.037.004-.299.16-.043.037-.04.136h.033l.302-.154.047-.041v-.001Zm-.697.247-.043.13h.028l.266-.134.043-.037.04-.136-.032.002-.263.14-.038.034-.001.001Zm-.316.167-.045.126.024.002.235-.12.039-.034.043-.13h-.027l-.234.124-.035.032Zm-.282.15-.046.12.02.003.211-.106.035-.032.045-.125h-.023l-.209.11-.033.03Zm-.253.134-.048.116.018.004.189-.096.033-.03.046-.12-.02-.002-.188.1-.03.027v.001Zm-.229.122-.048.111.015.005.171-.087.03-.028.047-.116-.017-.002-.17.09-.028.027Zm-.182.085-.026.024-.048.108.013.005.155-.079.028-.026.047-.112-.014-.003-.155.083Zm2.326-.89.054-.046.032-.155-.045.005-.348.176-.048.041-.037.148h.039l.352-.17h.001Zm-.417.182.038-.148-.038.002-.303.153-.044.038-.041.142h.033l.306-.147.048-.04h.001Zm-.41.197.043-.141h-.032l-.266.135-.039.034-.045.136.028.003.269-.129.043-.038h-.001Zm-.613.189-.046.13.023.004.238-.114.039-.034.046-.136-.028-.001-.235.12-.037.03Zm-.283.143-.048.125.02.003.211-.101.037-.032.046-.13-.023-.002-.21.106-.033.03Zm-.255.128-.049.12.018.005.189-.091.033-.03.048-.125-.02-.003-.189.096-.03.028Zm-.23.115-.049.116.015.005.171-.082.031-.027.049-.12-.017-.005-.171.087-.028.026h-.001Zm-.209.105-.049.112.013.006.155-.075.028-.026.05-.115-.015-.005-.154.079-.027.024h-.001Zm2.343-.712.056-.045.035-.168-.046.002-.357.165-.049.041-.041.16.04.002.363-.156h-.001Zm-.428.166.041-.159h-.039l-.309.142-.044.038-.045.152.033.004.313-.135.05-.042Zm-.419.183.046-.152-.032-.002-.271.125-.04.035-.048.145.028.004.273-.118.044-.037Zm-.365.159.048-.145-.028-.004-.238.11-.037.033-.05.138.024.005.241-.104.04-.034Zm-.542.126-.051.132.02.007.213-.093.037-.032.05-.138-.023-.004-.212.098-.035.03h.001Zm-.256.117-.052.127.017.007.191-.083.034-.03.051-.132-.02-.005-.191.088-.031.028h.001Zm-.23.106-.052.122.015.007.171-.074.032-.027.051-.127-.017-.006-.171.08-.029.025Zm-.028 0-.155.072-.026.024-.052.118.013.007.154-.067.029-.025.052-.122-.014-.006-.001-.001Zm2.218-.62.058-.046.036-.177h-.046l-.363.157-.051.041-.043.168.04.004.369-.148Zm-.435.153.043-.167-.039-.003-.313.135-.046.037-.047.16.034.006.318-.127.051-.04h-.001Zm-.424.171.047-.159-.033-.004-.274.117-.04.035-.05.152.028.006.276-.11.046-.038v.001Zm-.37.15.05-.151-.027-.006-.241.104-.037.032-.052.144.024.007.243-.097.041-.034h-.001Zm-.544.102-.052.139.02.007.215-.086.037-.032.051-.144-.023-.006-.213.093-.034.03h-.001Zm-.257.11-.053.132.017.008.191-.077.034-.03.054-.137-.02-.006-.192.082-.031.027v.002Zm-.231.099-.054.126.015.009.172-.07.031-.027.053-.131-.017-.008-.171.074-.029.026Zm-.182.065-.027.024-.054.122.013.008.155-.062.029-.026.054-.127-.014-.007-.155.066-.001.002Zm2.39-.602.059-.045.038-.187-.047-.003-.369.147-.052.041-.044.177.04.007.376-.137h-.001Zm-.443.14.045-.176-.039-.005-.318.126-.046.038-.05.167.034.008.322-.118.052-.04Zm-.43.159.049-.167-.032-.006-.276.11-.042.035-.052.159.028.008.28-.102.046-.036-.001-.001Zm-.373.137.052-.158-.027-.007-.243.097-.038.031-.054.15.024.01.244-.09.042-.034v.001Zm-.545.078-.055.143.02.01.215-.078.038-.032.054-.15-.023-.008-.215.085-.034.03Zm-.072.15.056-.144-.019-.008-.191.076-.032.027-.056.137.017.01.192-.07.034-.03-.001.001Zm-.418.044-.056.13.015.01.171-.063.032-.027.056-.137-.017-.008-.171.068-.03.026Zm-.181.057-.027.025-.056.125.012.01.155-.057.029-.026.055-.13-.014-.009-.154.062Zm2.406-.502.06-.046.04-.196-.048-.007-.375.137-.053.04-.048.187.042.01.382-.126Zm-.451.124.048-.186-.039-.007-.323.117-.047.037-.052.176.034.01.327-.107.052-.041Zm-.436.145.052-.175-.033-.009-.279.102-.042.034-.055.165.028.011.283-.092.046-.037Zm-.377.125.055-.165-.027-.01-.245.09-.038.031-.057.157.024.011.246-.08.042-.034Zm-.329.11.056-.158-.023-.01-.215.08-.035.029-.058.15.019.01.217-.07.038-.032h.001Zm-.29.095.057-.148-.019-.01-.192.07-.032.027-.058.142.017.011.192-.063.034-.029h.001Zm-.258.085.058-.142-.016-.01-.172.063-.03.026-.057.135.014.011.172-.056.031-.027Zm-.23.077.058-.136-.014-.01-.155.056-.027.025-.058.129.012.011.154-.051.029-.025h.001Zm2.275-.313.062-.045.045-.216-.049-.01-.387.116-.054.04-.052.204.042.014.393-.103Zm-.462.095.052-.202-.04-.012-.33.1-.048.036-.056.19.034.015.333-.088.055-.04v.001Zm-.446.119.057-.19-.033-.012-.284.086-.043.034-.058.178.028.015.287-.075.048-.036h-.002Zm-.383.102.059-.178-.028-.013-.247.075-.039.031-.06.168.023.015.249-.065.043-.034Zm-.332.088.061-.168-.023-.012-.217.066-.036.028-.061.16.019.014.218-.057.038-.03h.001Zm-.292.078.061-.158-.019-.013-.192.058-.033.028-.061.15.016.015.192-.05.036-.03Zm-.258.069.062-.15-.017-.013-.171.052-.03.025-.061.143.014.014.171-.045.032-.026Zm-.229.061.061-.143-.013-.013-.154.047-.028.023-.06.137.011.013.153-.04.03-.025v.001Zm2.339-.308.063-.043.048-.23-.051-.015-.393.102-.056.04-.054.215.042.018.4-.087h.001Zm-.471.075.055-.213-.041-.015-.334.086-.049.037-.058.2.034.018.338-.074.055-.039Zm-.452.1.06-.199-.033-.016-.286.075-.044.034-.062.187.028.017.289-.062.048-.036Zm-.386.086.061-.187-.026-.015-.249.064-.04.031-.063.176.023.017.25-.054.044-.032Zm-.335.074.063-.175-.022-.015-.219.056-.035.029-.064.165.019.017.219-.048.039-.03Zm-.292.064.063-.165-.018-.015-.193.05-.032.027-.064.157.015.016.193-.041.036-.029Zm-.258.057.064-.157-.016-.014-.171.045-.03.025-.064.148.013.016.171-.037.033-.027v.001Zm-.229.051.063-.149-.013-.014-.154.04-.028.024-.063.142.011.015.153-.033.03-.025h.001Zm2.355-.181.065-.044.051-.244-.051-.02-.401.087-.057.04-.057.226.042.022.407-.068h.001Zm-.535.089.057-.039.057-.225-.04-.02-.339.073-.05.036-.062.21.034.022.342-.057h.001Zm-.401.04.062-.21-.033-.018-.29.062-.044.033-.065.196.028.02.292-.047.049-.036h.001Zm-.39.067.064-.195-.027-.018-.25.053-.04.03-.066.185.022.02.252-.043.045-.032Zm-.337.058.066-.184-.023-.017-.218.047-.036.029-.067.173.019.019.219-.036.04-.03v-.001Zm-.294.05.067-.172-.018-.017-.193.04-.033.028-.067.163.016.018.192-.033.036-.028Zm-.257.044.066-.163-.015-.016-.171.037-.031.025-.066.155.013.017.17-.028.033-.026h.001Zm-.228.04.066-.155-.013-.016-.153.033-.028.023-.066.148.011.017.152-.025.03-.025h.001Zm1.972-.262-.061.24.043.027.415-.046.067-.042.054-.26-.052-.025-.408.066-.058.04Zm-.464.073-.065.222.034.025.347-.04.057-.038.062-.239-.041-.023-.343.057-.051.036Zm-.395.063-.068.206.028.024.294-.033.05-.035.066-.22-.033-.023-.291.047-.046.034Zm-.339.054-.069.193.022.022.252-.028.046-.032.068-.206-.027-.02-.252.041-.04.03Zm-.296.046-.07.18.019.022.219-.024.04-.03.07-.192-.022-.02-.22.036-.036.028Zm-.26.042-.069.17.015.02.193-.02.036-.028.069-.18-.017-.02-.193.031-.033.027h-.001Zm-.229.036-.069.16.012.02.17-.02.033-.025.069-.17-.015-.019-.17.028-.03.024v.002Zm-.206.032-.067.153.01.018.151-.017.03-.023.068-.16-.012-.019-.151.026-.029.023Z",
  fill: "#00897E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "m214.787 92.766-1.182.69-1.005 2.251 2.187-2.941Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.189 94.267h-.554v2.016h.554v-2.016Z",
  fill: "#5C666E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M217.79 94.267h-.085v2.016h.085v-2.016Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M218.117 94.267h-.131v2.016h.131v-2.016Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m220.131 95.092-4.851.339-.044-.072 4.866-.938.091.494-.062.177Z",
  fill: "#131A1D"
}), /*#__PURE__*/React.createElement("path", {
  d: "m221.321 89.034-.113-.022-4.276 2.552-1.696 3.794 4.957-.444 1.128-5.88Z",
  fill: "#424D54"
}), /*#__PURE__*/React.createElement("path", {
  d: "m216.892 91.534 4.314-2.522-.279 1.432-4.502 2.135.467-1.045Zm-1.03 2.306 4.696-1.5.354-1.818-4.511 2.111-.539 1.208v-.001Zm-.659 1.475 4.87-.488.465-2.385-4.705 1.462-.63 1.411Z",
  fill: "#E5E6EC"
}), /*#__PURE__*/React.createElement("path", {
  d: "m220.321 89.819-.063.01.054-.217.077-.07.555-.32.072-.017-.047.225-.086.075-.562.314Zm-.104.032.055-.216-.061.01-.487.283-.07.063-.062.21.054-.006.494-.275.077-.069Zm-.661.37.062-.209-.052.008-.432.25-.064.06-.066.202.046-.004.436-.244.069-.062h.001Zm-.583.327.066-.202-.045.005-.386.223-.057.054-.071.195.04-.001.389-.217.064-.058v.001Zm-.521.292.07-.195-.039.002-.346.201-.054.05-.072.19h.034l.349-.194.058-.054Zm-.467.261.073-.188h-.034l-.313.181-.049.047-.074.183.03.002.314-.175.053-.05Zm-.42.236.074-.181h-.03l-.283.163-.046.044-.075.177.026.004.284-.16.05-.046Zm-.382.214.076-.177-.026-.002-.258.15-.043.042-.076.17.023.005.259-.144.046-.044h-.001Zm3.634-1.732.087-.075.049-.235-.073.013-.564.314-.078.069-.058.227.064-.008.573-.305Zm-1.257.67.501-.266.078-.068.058-.227-.062.01-.494.275-.071.063-.064.219.054-.004v-.001Zm-.58.113-.07.211.047-.001.442-.236.07-.063.064-.218-.052.005-.437.244-.065.058h.001Zm-.525.292-.073.202h.04l.393-.208.064-.058.07-.21-.045.003-.389.217-.059.054h-.001Zm-.47.26-.075.196.034.003.351-.187.059-.053.074-.203h-.04l-.348.195-.055.05v-.001Zm-.424.234-.076.19.029.003.316-.169.054-.05.076-.195-.035-.001-.314.174-.05.048Zm-.384.213-.077.182.026.006.285-.153.05-.046.077-.189-.029-.002-.285.158-.047.044Zm-.305.152-.043.041-.079.177.023.005.259-.138.047-.043.078-.182-.026-.004-.259.144Zm3.874-1.603.089-.076.051-.247-.074.011-.573.306-.08.07-.06.237.065-.005.582-.296Zm-.689.321.061-.237-.063.007-.501.266-.072.063-.067.228.055-.001.508-.258.08-.068h-.001Zm-1.171.416-.073.219h.047l.447-.226.072-.063.067-.227-.053.003-.442.235-.065.058v.001Zm-.53.28-.075.211.04.003.395-.201.066-.058.072-.218h-.045l-.393.21-.06.053Zm-.473.251-.078.203.035.004.353-.179.059-.053.076-.21-.039-.002-.351.188-.055.05Zm-.426.226-.079.195.03.006.317-.161.055-.05.077-.203-.033-.003-.315.168-.051.048h-.001Zm-.385.203-.08.189.026.006.286-.145.05-.047.08-.195-.03-.005-.285.153-.047.044Zm-.306.144-.043.041-.081.182.023.007.26-.131.047-.044.08-.188-.026-.006-.26.138Zm3.906-1.495.091-.076.054-.26-.075.009-.583.295-.081.07-.063.248.065-.001.592-.285Zm-.7.307.064-.249-.063.004-.508.257-.073.064-.071.238.056.001.515-.246.081-.07h-.001Zm-.688.332.071-.238h-.054l-.446.227-.067.058-.075.229.046.003.452-.216.073-.063Zm-1.03.316-.078.22.04.004.399-.191.066-.058.075-.228-.046-.001-.395.2-.061.054Zm-.476.24-.081.21.034.007.356-.17.061-.054.078-.218-.039-.004-.353.18-.056.05v-.001Zm-.427.215-.082.202.029.008.319-.153.054-.05.082-.21-.033-.005-.317.16-.052.048Zm-.386.194-.083.195.025.008.287-.137.052-.047.082-.202-.029-.006-.286.145-.047.044h-.001Zm-.35.176-.083.188.021.01.26-.126.047-.043.083-.194-.025-.007-.259.131-.044.042v-.001Zm3.934-1.194.094-.076.058-.282-.077.002-.599.277-.084.07-.068.268.067.004.609-.263Zm-.719.278.068-.267-.065-.001-.519.24-.075.063-.075.255.055.006.526-.228.084-.068h.001Zm-.703.307.075-.255-.054-.004-.455.21-.068.058-.08.244.047.008.459-.199.075-.062h.001Zm-.614.268.08-.243-.045-.006-.401.185-.062.055-.083.232.04.01.403-.175.068-.058Zm-.909.21-.086.224.034.01.359-.156.061-.053.084-.232-.039-.007-.357.165-.056.05Zm-.43.198-.087.214.029.011.321-.138.056-.05.086-.222-.033-.008-.32.147-.052.046Zm-.388.178-.087.205.024.012.289-.125.051-.046.087-.213-.029-.01-.287.133-.048.043Zm-.045 0-.26.12-.045.041-.087.198.021.011.26-.112.048-.044.088-.204-.025-.01Zm3.725-1.042.096-.076.061-.296h-.078l-.61.261-.085.07-.071.282.068.007.619-.248Zm-.731.258.072-.281-.066-.005-.526.227-.076.063-.08.268.057.01.533-.214.085-.069h.001Zm-.713.288.08-.267-.055-.008-.459.198-.069.059-.084.254.047.011.463-.185.077-.062Zm-.62.25.084-.253-.046-.01-.404.175-.062.054-.088.243.039.012.408-.163.069-.058Zm-.913.173-.089.231.034.013.36-.144.063-.054.087-.242-.039-.01-.358.155-.057.05h-.001Zm-.432.184-.09.222.029.014.321-.129.057-.049.09-.23-.033-.012-.321.139-.053.046Zm-.388.166-.09.212.024.014.289-.115.051-.046.091-.22-.028-.013-.288.125-.049.043Zm-.305.109-.044.04-.091.205.022.014.26-.104.048-.043.09-.211-.023-.012-.26.112-.002-.001Zm4.014-1.011.098-.076.064-.312-.079-.006-.62.247-.087.07-.076.296.069.012.63-.23.001-.001Zm-.744.235.076-.295-.066-.009-.534.212-.078.064-.083.28.056.014.541-.198.087-.068h.001Zm-.723.266.083-.28-.055-.01-.464.185-.07.059-.087.265.047.015.469-.17.077-.063Zm-.627.232.088-.266-.046-.011-.407.161-.063.054-.091.253.039.015.41-.15.07-.057Zm-.915.13-.092.241.033.016.362-.133.063-.053.091-.252-.038-.013-.361.144-.058.05Zm-.118.251.092-.24-.032-.013-.322.128-.053.046-.093.23.028.017.322-.118.058-.049Zm-.703.075-.093.22.023.015.288-.105.053-.046.093-.229-.028-.014-.288.115-.049.044h.001Zm-.305.097-.045.04-.094.212.021.016.259-.096.049-.043.093-.22-.023-.013-.26.103v.001Zm4.041-.845.102-.075.068-.33-.081-.011-.631.23-.089.068-.079.313.069.016.641-.21Zm-.756.209.08-.311-.067-.013-.541.197-.079.063-.087.294.057.018.548-.18.089-.068Zm-.732.243.086-.293-.054-.014-.469.17-.071.058-.092.278.046.017.474-.155.079-.062h.001Zm-.634.21.092-.278-.046-.015-.41.15-.064.052-.095.264.039.019.413-.135.071-.057Zm-.553.183.095-.263-.038-.016-.363.132-.058.05-.096.25.032.019.365-.12.063-.052Zm-.487.162.096-.25-.032-.016-.323.117-.053.046-.097.238.028.019.323-.106.059-.048h-.001Zm-.433.144.097-.239-.027-.016-.288.104-.05.044-.097.228.024.018.288-.094.053-.045Zm-.385.127.097-.227-.023-.017-.26.094-.046.041-.097.218.02.019.26-.085.049-.043Zm3.82-.525.105-.074.075-.363-.083-.019-.649.196-.092.069-.086.34.07.024.66-.173Zm-.777.16.087-.338-.067-.02-.554.167-.081.062-.094.319.057.025.56-.147.091-.066.001-.001Zm-.748.2.094-.318-.055-.02-.477.144-.073.057-.098.3.047.025.481-.126.081-.061v-.001Zm-.644.171.099-.298-.046-.021-.415.125-.065.052-.102.283.039.024.417-.11.072-.055h.001Zm-.558.15.101-.282-.038-.021-.365.11-.059.049-.103.267.033.024.365-.096.066-.052Zm-.491.13.103-.266-.031-.021-.323.098-.054.045-.103.253.027.024.324-.084.059-.048-.002-.001Zm-.433.115.104-.252-.028-.02-.288.087-.049.043-.103.24.022.024.288-.076.054-.045Zm-.386.103.103-.24-.022-.02-.258.078-.046.04-.103.23.02.022.257-.068.05-.042h-.001Zm3.928-.516.107-.074.08-.385-.084-.026-.661.172-.094.068-.091.36.07.03.672-.145h.001Zm-.791.125.092-.358-.068-.026-.56.146-.083.061-.099.335.058.03.567-.122.093-.067Zm-.758.167.099-.334-.054-.025-.482.125-.073.057-.103.313.047.03.485-.105.083-.06h-.002Zm-.649.144.103-.313-.045-.026-.418.109-.066.052-.106.295.038.029.421-.09.073-.056Zm-.563.124.106-.294-.037-.026-.366.095-.06.048-.108.279.032.027.368-.079.065-.05Zm-.491.109.107-.278-.031-.024-.324.083-.055.046-.107.263.026.026.324-.07.06-.047Zm-.433.096.108-.263-.026-.024-.288.074-.051.043-.106.25.022.026.287-.063.055-.044h-.001Zm-.385.085.107-.25-.022-.023-.258.067-.047.04-.105.238.019.025.256-.055.051-.041-.001-.001Zm3.955-.304.11-.073.085-.41-.086-.032-.673.144-.095.067-.097.38.072.038.684-.114Zm-.9.15.096-.065.097-.379-.069-.032-.568.122-.084.06-.104.354.057.036.574-.095.001-.001Zm-.673.066.104-.35-.055-.032-.486.104-.075.056-.109.329.047.035.49-.082.084-.06Zm-.655.113.109-.328-.045-.03-.421.09-.067.051-.111.31.038.033.422-.07.075-.055v-.001Zm-.565.097.111-.308-.037-.03-.367.079-.062.048-.111.29.031.032.368-.06.066-.051h.001Zm-.492.084.111-.29-.03-.028-.324.07-.055.044-.111.274.025.03.323-.053.061-.047Zm-.434.074.112-.273-.026-.027-.287.061-.051.042-.111.26.022.029.287-.047.054-.044Zm-.383.066.11-.259-.021-.027-.257.055-.047.04-.11.246.018.028.256-.042.051-.042Zm3.312-.44-.103.403.072.045.697-.078.114-.071.09-.438-.087-.04-.685.112-.098.067Zm-.779.123-.109.373.057.043.582-.065.098-.064.103-.402-.069-.038-.576.094-.085.06h-.001Zm-.663.105-.114.346.046.04.494-.055.085-.058.111-.372-.056-.037-.49.08-.076.056Zm-.57.09-.116.325.037.037.424-.047.076-.054.114-.345-.045-.035-.423.07-.068.05h.001Zm-.496.079-.117.303.03.037.368-.042.069-.05.116-.322-.036-.034-.369.06-.061.047v.001Zm-.436.069-.116.286.025.035.323-.036.061-.047.116-.303-.03-.031-.324.052-.056.045.001-.001Zm-.386.061-.116.27.021.033.285-.032.056-.043.116-.285-.024-.03-.287.046-.051.041Zm-.344.055-.114.257.017.03.254-.028.051-.04.115-.27-.021-.029-.255.041-.047.039Z",
  fill: "#00897E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "m218.874 90.375-1.984 1.16-1.689 3.78 3.673-4.94Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.083 92.992h-.905v3.29h.905v-3.29Z",
  fill: "#5C666E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M223.436 92.992h-.139v3.29h.139v-3.29Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M223.965 92.992h-.213v3.29h.213v-3.29Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m227.249 94.341-7.918.552-.071-.118 7.942-1.528.149.804-.102.29Z",
  fill: "#131A1D"
}), /*#__PURE__*/React.createElement("path", {
  d: "m229.191 84.453-.184-.036-6.978 4.165-2.769 6.194 8.091-.724 1.84-9.599Z",
  fill: "#424D54"
}), /*#__PURE__*/React.createElement("path", {
  d: "m221.964 88.534 7.042-4.117-.456 2.337-7.348 3.485.762-1.705Zm-1.682 3.764 7.666-2.448.577-2.967-7.364 3.445-.879 1.97Zm-1.075 2.407 7.95-.796.759-3.895-7.68 2.387-1.029 2.304Z",
  fill: "#E5E6EC"
}), /*#__PURE__*/React.createElement("path", {
  d: "m227.559 85.733-.103.017.09-.355.125-.113.905-.524.118-.026-.076.367-.14.122-.919.513Zm-.169.054.091-.355-.1.019-.796.461-.114.104-.1.342.088-.01.806-.45.125-.111Zm-1.078.604.102-.342-.086.013-.705.409-.104.095-.109.33.076-.005.712-.397.113-.102.001-.001Zm-.954.534.109-.33-.073.008-.63.364-.094.089-.115.32.065-.003.635-.354.103-.094Zm-.849.476.115-.319-.063.004-.565.328-.088.082-.118.308.056.002.569-.317.095-.088h-.001Zm-.762.426.119-.307h-.056l-.51.296-.081.077-.122.298.049.004.513-.286.087-.082h.001Zm-.686.386.121-.298-.048-.002-.463.269-.075.072-.123.288.042.006.464-.258.081-.077h.001Zm-.622.348.123-.288-.042-.004-.423.245-.07.068-.124.279.038.007.423-.236.076-.072-.001.001Zm5.931-2.828.142-.122.08-.384-.12.021-.919.513-.128.112-.095.37.105-.012.935-.498Zm-2.052 1.095.817-.436.127-.111.095-.37-.101.015-.806.449-.116.103-.105.358.089-.007Zm-.946.183-.114.344.076-.002.72-.384.116-.102.106-.357-.086.01-.713.396-.105.096Zm-.857.476-.119.331.065.002.641-.342.104-.094.114-.343-.074.005-.635.353-.096.088Zm-.768.425-.122.32.056.004.572-.305.097-.087.119-.331h-.064l-.569.317-.089.082Zm-.691.383-.125.309.048.007.516-.276.088-.08.123-.32-.055-.002-.513.286-.082.077Zm-.626.348-.127.297.043.009.465-.249.082-.076.125-.308-.048-.004-.464.259-.077.072h.001Zm-.498.248-.072.068-.127.288.037.01.424-.226.075-.072.127-.297-.042-.006-.422.236v-.001Zm6.323-2.618.146-.124.084-.403-.121.018-.936.498-.13.113-.098.388.106-.008.95-.483h-.001Zm-1.124.525.099-.387-.102.01-.817.436-.118.103-.11.373.09-.003.829-.42.13-.112h-.001Zm-1.911.678-.118.358.076.001.729-.37.118-.101.11-.372-.087.005-.721.384-.106.096-.001-.001Zm-.864.458-.124.344.065.005.646-.328.106-.094.119-.357h-.074l-.641.342-.097.088Zm-.773.409-.127.331.056.008.576-.293.097-.087.124-.343-.064-.003-.572.305-.09.082Zm-.695.368-.13.319.048.01.517-.263.09-.081.127-.33-.055-.005-.515.274-.082.077Zm-.628.333-.131.307.042.011.467-.237.083-.077.13-.318-.048-.007-.466.248-.077.072v.001Zm-.5.234-.071.069-.132.296.037.013.423-.216.077-.07.131-.307-.042-.01-.423.226Zm6.376-2.44.149-.123.088-.424-.123.013-.951.482-.133.114-.103.406.107-.003.967-.465h-.001Zm-1.143.501.103-.405-.102.006-.83.42-.119.103-.115.39.09.002.84-.403.133-.113Zm-1.123.542.115-.387h-.088l-.729.37-.108.095-.123.373.076.006.736-.354.12-.103h.001Zm-1.682.517-.128.358.065.008.651-.312.108-.094.123-.372-.074-.003-.646.327-.098.088h-.001Zm-.777.392-.132.343.055.01.58-.277.099-.088.128-.356-.064-.006-.576.292-.09.082Zm-.698.35-.134.33.048.013.52-.25.09-.08.132-.343-.055-.009-.517.262-.084.077Zm-.63.318-.135.317.041.014.468-.224.083-.076.134-.329-.047-.01-.467.236-.078.073h.001Zm-.571.288-.136.306.036.016.425-.204.077-.072.135-.316-.041-.012-.424.215-.072.068v-.001Zm6.421-1.95.153-.124.095-.46-.126.004-.978.452-.137.113-.111.438.109.006.994-.43h.001Zm-1.174.454.112-.437-.105-.001-.847.391-.122.104-.123.417.091.01.858-.372.137-.112h-.001Zm-1.147.501.123-.416-.089-.007-.742.343-.11.095-.131.398.076.012.75-.324.122-.102.001.001Zm-1.003.437.132-.397-.075-.01-.655.302-.101.088-.136.38.065.016.66-.286.111-.094-.001.001Zm-1.484.344-.14.364.054.017.586-.253.1-.086.137-.38-.063-.012-.582.269-.092.082Zm-.703.323-.142.349.047.018.523-.226.092-.08.14-.364-.054-.014-.522.24-.085.077h.001Zm-.633.29-.142.335.04.019.47-.203.085-.076.142-.348-.047-.015-.468.216-.079.072h-.001Zm-.074-.002-.425.196-.073.067-.143.322.035.02.425-.183.078-.07.143-.335-.04-.017Zm6.079-1.701.158-.124.1-.484-.128-.002-.995.429-.139.114-.116.46.109.012 1.011-.404v-.001Zm-1.193.422.118-.459-.106-.007-.859.37-.125.104-.129.436.092.016.871-.349.139-.111h-.001Zm-1.163.47.129-.436-.088-.011-.75.323-.112.095-.137.416.077.018.758-.303.124-.102h-.001Zm-1.014.408.138-.414-.075-.014-.66.285-.102.088-.142.395.064.02.666-.266.111-.093Zm-1.489.282-.145.379.055.021.588-.235.103-.087.142-.395-.064-.016-.585.252-.093.082-.001-.001Zm-.705.302-.147.362.046.022.525-.21.092-.08.146-.377-.054-.018-.523.225-.086.076h.001Zm-.633.271-.148.346.04.023.471-.188.085-.075.147-.36-.046-.02-.47.203-.079.071Zm-.499.178-.073.066-.147.333.034.023.423-.17.079-.07.148-.346-.039-.02-.425.184Zm6.552-1.65.161-.124.106-.511-.13-.01-1.012.403-.142.114-.123.483.111.02 1.029-.376Zm-1.213.383.123-.482-.107-.014-.871.347-.127.103-.135.458.092.021.883-.322.142-.112v.001Zm-1.18.435.135-.456-.089-.017-.758.302-.114.094-.143.435.077.023.765-.28.127-.1Zm-1.024.378.143-.433-.075-.02-.665.266-.103.087-.148.412.065.026.669-.245.114-.093Zm-1.493.213-.152.393.055.026.591-.216.102-.086.149-.411-.063-.02-.589.234-.094.081h.001Zm-.195.41.152-.393-.054-.022-.524.209-.087.075-.152.375.046.026.525-.192.094-.08v.001Zm-1.147.12-.153.36.039.026.471-.172.086-.074.153-.374-.046-.023-.47.187-.08.071Zm-.498.16-.074.066-.153.344.034.027.423-.155.08-.07.154-.358-.04-.024-.423.17h-.001Zm6.596-1.379.166-.123.111-.54-.132-.017-1.03.374-.146.113-.128.51.112.026 1.047-.343Zm-1.234.341.13-.508-.108-.02-.884.32-.128.103-.142.48.093.029.894-.293.145-.111Zm-1.196.396.143-.478-.089-.024-.766.278-.116.095-.149.454.076.03.773-.253.129-.1-.001-.002Zm-1.033.344.149-.453-.075-.025-.67.243-.105.087-.155.43.065.031.674-.22.116-.093h.001Zm-.903.3.154-.43-.062-.026-.592.215-.096.08-.157.41.054.03.594-.195.104-.085h.001Zm-.796.263.157-.408-.052-.027-.526.192-.087.075-.159.39.046.03.527-.172.094-.079v-.001Zm-.705.234.158-.388-.044-.028-.471.171-.08.07-.159.372.039.03.471-.154.086-.074Zm-.631.21.159-.371-.039-.028-.423.154-.075.067-.158.355.033.03.423-.139.08-.07v.001Zm6.238-.857.171-.121.122-.593-.136-.031-1.059.32-.15.112-.141.555.114.04 1.078-.282h.001Zm-1.268.262.141-.553-.109-.033-.903.273-.133.101-.153.52.093.04.914-.239.15-.11Zm-1.222.325.154-.518-.091-.034-.778.236-.118.093-.161.488.076.04.785-.205.132-.1h.001Zm-1.05.28.16-.487-.074-.035-.677.205-.107.087-.165.46.063.04.682-.178.118-.092Zm-.913.243.165-.46-.062-.034-.595.18-.097.08-.168.436.053.04.598-.158.106-.084Zm-.8.213.168-.435-.052-.035-.527.16-.089.075-.168.413.044.039.528-.139.097-.078h-.001Zm-.707.189.169-.413-.044-.034-.47.142-.081.07-.168.393.037.038.47-.123.089-.073h-.002Zm-.629.168.167-.393-.037-.034-.422.128-.076.066-.166.374.031.037.42-.11.082-.069h.001Zm6.411-.843.175-.12.13-.63-.138-.04-1.078.28-.153.11-.149.587.115.051 1.098-.237v-.001Zm-1.29.203.149-.583-.111-.042-.914.237-.135.1-.162.548.094.05.926-.2.153-.11Zm-1.238.274.162-.544-.091-.042-.785.204-.12.092-.169.513.076.048.793-.171.134-.1Zm-1.06.235.169-.51-.074-.042-.682.177-.108.085-.172.482.062.047.686-.15.12-.09h-.001Zm-.918.202.173-.48-.061-.04-.598.155-.097.079-.175.455.052.046.599-.13.108-.083-.001-.002Zm-.802.178.175-.454-.051-.04-.528.138-.09.073-.175.43.043.045.528-.115.098-.077Zm-.707.156.175-.43-.043-.038-.469.122-.083.068-.174.409.036.042.469-.102.089-.072Zm-.629.139.174-.408-.035-.038-.421.11-.076.064-.172.389.029.04.42-.09.082-.068h-.001Zm6.455-.496.179-.119.139-.67-.14-.052-1.098.234-.157.11-.157.62.117.062 1.117-.185Zm-1.468.244.156-.106.158-.618-.112-.053-.927.198-.138.1-.169.576.093.06.938-.157h.001Zm-1.098.108.17-.574-.09-.05-.793.17-.122.09-.177.538.075.056.8-.133.137-.097Zm-1.069.184.177-.536-.074-.05-.686.147-.111.085-.18.503.062.054.689-.115.122-.088h.001Zm-.923.159.18-.502-.06-.048-.599.128-.1.079-.182.474.051.052.601-.1.109-.082V93.5Zm-.805.138.183-.473-.051-.046-.529.113-.09.073-.182.448.042.05.528-.089.099-.076Zm-.707.121.182-.446-.041-.044-.469.1-.083.069-.181.424.035.048.468-.079.09-.07-.001-.002Zm-.626.108.18-.423-.034-.043-.42.09-.076.064-.178.403.028.046.417-.07.083-.067Zm5.407-.719-.167.659.118.075 1.137-.129.185-.116.147-.713-.141-.067-1.119.183-.16.108Zm-1.271.202-.179.608.093.07.951-.107.159-.105.168-.655-.112-.063-.939.154-.14.098h-.001Zm-1.081.171-.186.565.074.066.807-.09.139-.096.18-.605-.09-.06-.801.13-.124.091h.001Zm-.932.147-.19.528.061.063.693-.078.123-.087.187-.564-.074-.057-.689.113-.111.082Zm-.81.13-.191.495.049.059.602-.068.11-.08.19-.527-.06-.055-.601.098-.1.077h.001Zm-.712.112-.19.467.041.055.527-.059.1-.075.19-.494-.049-.053-.528.087-.091.072Zm-.63.1-.188.441.033.053.466-.052.091-.07.189-.466-.04-.05-.468.077-.083.067Zm-.562.089-.186.418.028.05.415-.046.083-.066.188-.439-.034-.048-.417.068-.077.064v-.001Z",
  fill: "#00897E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "m225.202 86.64-3.238 1.893-2.757 6.171 5.995-8.063Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m230.954 77.506.675.15 1.53.47.38-.026s.3-.32.33-.726c.03-.407-.36-.558-.36-.558l-2.362-.57s-.313.24-.313.48.12.78.12.78Z",
  fill: "#9299A2"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M233.869 77.374c.03-.407-.36-.558-.36-.558l-2.362-.57s-.313.24-.313.48c.746.229 2.066.311 3.036.648h-.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M231.21 76.93c-.045.301-.209.526-.365.503-.155-.024-.246-.287-.201-.588.046-.301.209-.527.366-.503.156.024.245.287.2.588Z",
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "m230.955 77.506.674.15 1.53.469.38-.026s-.214-.63-2.705-1.373c0 .24.12.78.12.78h.001Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m230.696 76.715-.981-3.026-3.976-4.272-.245.166 4.958 7.298.244-.166Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m225.741 69.424-.245.166 4.957 7.298.245-.166-4.957-7.298Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m226.587 70.327-.402.271-.234-.344.349-.235.287.308ZM226.025 69.725l-.298.202-.233-.344.245-.166.286.308Z",
  fill: "#FF1636"
}), /*#__PURE__*/React.createElement("path", {
  d: "m230.621 76.868 3.114.664 5.693-1.302-.021-.295-8.807.64.021.293Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m239.407 75.932-8.807.638.021.295 8.808-.638-.022-.295Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m238.216 76.507-.034-.483.415-.03.03.419-.411.094ZM239.018 76.324l-.026-.359.416-.03.021.295-.411.094Z",
  fill: "#FF1636"
}), /*#__PURE__*/React.createElement("path", {
  d: "m230.526 76.727-2.133 2.362-1.717 5.575.266.129 3.851-7.937-.267-.129Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m230.511 76.716-3.851 7.936.266.129 3.85-7.937-.265-.128Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m227.042 83.476.437.21-.183.376-.378-.184.124-.402ZM226.799 84.262l.326.156-.183.375-.266-.129.123-.402Z",
  fill: "#FF1636"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.984 76.872c.034-.31-.042-.642-.267-.582-.225.06-.632.36-.617.466.016.105.314.386.545.483.232.095.312-.12.339-.367Z",
  fill: "#9299A2"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M230.72 76.34c.055-.01.116.052.114.114-.001.063-.66.245-.66.245s.195-.164.262-.21c.084-.059.228-.14.284-.15Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m233.228 96.109-.526-18.002h-.002a.442.442 0 0 0-.25-.432.88.88 0 0 0-.685-.1.613.613 0 0 0-.516.532h-.002l-.526 18.002h2.507Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M231.973 78.178c.754 0 .747.27.747.603l-.02-.83c0-.323.017-.584-.723-.584-.741 0-.727.261-.727.584l-.023.83c0-.333-.008-.603.746-.603Z",
  fill: "#AEB3BC"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M232.838 96.109h-.758l.022-17.983c0-.32-.004-.578.219-.578.224 0 .219.259.219.578l.298 17.983Z",
  fill: "#000"
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M231.062 96.109h.39l.127-17.887c0-.318.003-.575-.113-.575-.115 0-.112.257-.112.575l-.292 17.887Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.906 95.246h-3.894v.862h3.894v-.862Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M231.114 95.246h-.596v.862h.596v-.862Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M233.391 95.246h-.914v.862h.914v-.862Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m238.383 83.714.449.1 1.019.313.254-.018s.2-.212.22-.483c.02-.272-.24-.372-.24-.372l-1.573-.38s-.209.16-.209.32.08.52.08.52Z",
  fill: "#9299A2"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M240.325 83.626c.02-.271-.24-.37-.24-.37l-1.573-.381s-.209.16-.209.32c.497.152 1.376.207 2.022.43v.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.553 83.33c-.031.202-.14.351-.243.336-.104-.016-.164-.191-.134-.392.03-.2.139-.35.242-.335.105.015.164.19.134.392h.001Z",
  fill: "url(#c)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "m238.383 83.714.449.1 1.019.313.254-.018s-.143-.42-1.802-.915c0 .16.08.52.08.52Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m239.897 96.108-.351-11.993h-.001a.295.295 0 0 0-.167-.288.586.586 0 0 0-.456-.067.406.406 0 0 0-.343.355h-.001l-.351 11.993h1.67Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.062 84.162c.502 0 .497.18.497.402l-.013-.553c0-.215.012-.389-.482-.389s-.484.174-.484.39l-.016.552c0-.222-.004-.402.498-.402Z",
  fill: "#AEB3BC"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M239.638 96.108h-.505l.015-11.981c0-.213-.003-.386.146-.386.15 0 .145.173.145.386l.199 11.98Z",
  fill: "#000"
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M238.455 96.108h.26l.084-11.916c0-.212.002-.383-.075-.383s-.075.171-.075.383l-.194 11.916Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240.35 95.534h-2.594v.574h2.594v-.574Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M238.491 95.534h-.397v.574h.397v-.574Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M240.008 95.534h-.61v.574h.61v-.574Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m238.193 83.299 1.882.98 3.887.178.038-.194-5.767-1.157-.04.193Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m238.222 83.1-.038.193 5.768 1.157.038-.193-5.768-1.157Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m243.133 84.418.064-.316.272.055-.055.275-.281-.014ZM243.682 84.444l.047-.235.272.055-.039.193-.28-.013Z",
  fill: "#FF1636"
}), /*#__PURE__*/React.createElement("path", {
  d: "m238.157 83.19-1.791 1.138-2.096 3.273.148.13 3.887-4.41-.148-.13Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m238.147 83.175-3.887 4.41.148.13 3.887-4.41-.148-.13Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m234.717 86.904.243.213-.183.208-.211-.186.151-.235ZM234.421 87.365l.18.159-.183.207-.148-.13.151-.236Z",
  fill: "#FF1636"
}), /*#__PURE__*/React.createElement("path", {
  d: "m238.271 83.213-.09-2.117-1.789-3.45-.187.063 1.88 5.567.186-.063Z",
  fill: "#C9CCD4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m236.394 77.674-.187.063 1.879 5.568.187-.063-1.879-5.568Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m236.77 78.382-.306.102-.089-.262.266-.09.129.25ZM236.521 77.894l-.228.077-.088-.262.187-.063.129.248Z",
  fill: "#FF1636"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.403 83.292c.023-.206-.027-.427-.177-.387-.151.04-.422.24-.411.31.009.07.209.257.363.32.154.064.207-.079.225-.243Z",
  fill: "#9299A2"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M238.229 82.938c.037-.006.078.035.077.076-.002.042-.441.163-.441.163s.129-.11.175-.14a.755.755 0 0 1 .189-.1v.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.304 95.784c.802-.125 1.429-1.006 1.612-2.05.183-1.043.099-2.02-.527-1.515-.626.506-.885-.252-.708-.847.479-1.616-.157-4.43-.873-3.551-.717.878-.003.674-.889-.328s-2.754-1.285-1.96.315c.793 1.599 2.033 2.912 1.234 2.512-.799-.4-2.046-.288-1.249.636.797.925 2.037 2.163 1.414 2.144-.623-.02-2.845-.763-1.072.866 1.773 1.63 3.019 1.818 3.019 1.818h-.001Z",
  fill: "#00AF69"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.754 87.458c.404.618.762 1.265 1.087 1.926.324.662.608 1.344.826 2.046l.079.264.02.066.016.066.034.133.066.267.052.27c.017.09.037.18.049.27l.04.273a20.036 20.036 0 0 1 .158 1.646c.018.366.028.735.016 1.097l.215.007c.002-.376-.016-.745-.044-1.116a18.572 18.572 0 0 0-.198-1.655l-.048-.274c-.015-.09-.037-.182-.056-.273l-.059-.273-.074-.268-.037-.135-.019-.067-.021-.066-.087-.264a14.269 14.269 0 0 0-.88-2.037 18.12 18.12 0 0 0-1.135-1.902v-.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.646 91.017c-.002-.187.01-.374.03-.561.02-.187.05-.374.086-.559.037-.184.08-.369.129-.551.05-.183.105-.364.171-.542a7.996 7.996 0 0 0-.348 1.082 7.044 7.044 0 0 0-.112.56 4.937 4.937 0 0 0-.055.57h.099v.001ZM212.377 94.622c.023-.051.056-.108.088-.162a2.58 2.58 0 0 1 .357-.449c.092-.09.187-.177.292-.254.051-.04.106-.076.16-.112.054-.036.112-.067.168-.101-.059.028-.12.053-.177.083-.058.03-.117.06-.173.095a2.749 2.749 0 0 0-.746.656c-.041.054-.08.107-.117.17l.148.074ZM212.278 93.776a9.3 9.3 0 0 0-.695-.592 7.222 7.222 0 0 0-.37-.266 4.643 4.643 0 0 0-.391-.232c.128.082.249.171.367.265a7.604 7.604 0 0 1 .663.61c.104.107.208.217.305.328l.12-.113h.001ZM211.995 92.299a6.005 6.005 0 0 0-.428-.383 6.778 6.778 0 0 0-.458-.34 5.16 5.16 0 0 0-.49-.292 3.495 3.495 0 0 0-.525-.217c.176.07.346.151.509.247.161.097.318.2.467.316a5.895 5.895 0 0 1 .827.759l.097-.09h.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.76 96.541c-.692-.145-1.235-.932-1.395-1.841-.161-.91-.09-1.748.451-1.284.54.465.778-.18.608-.697-.435-1.326.125-3.812.745-3.022s.525.165.766-.242c.569-.966 2.371-.982 1.69.36-.68 1.343-1.747 2.42-1.058 2.111.688-.308 1.764-.154 1.079.606s-1.751 1.771-1.214 1.783c.536.012 2.451-.527.927.797-1.525 1.324-2.599 1.43-2.599 1.43Z",
  fill: "#5EB85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.939 89.478a14.553 14.553 0 0 0-.98 1.606 11.623 11.623 0 0 0-.752 1.728l-.074.225c-.024.076-.042.152-.064.228-.02.076-.043.152-.061.229l-.049.231c-.036.155-.059.31-.085.466l-.036.233-.032.233c-.04.312-.072.626-.095.94a11.92 11.92 0 0 0-.033.948l.165-.006a12.11 12.11 0 0 1 .012-.933c.016-.311.041-.623.074-.933l.027-.233.03-.233c.023-.154.043-.31.075-.462l.044-.23c.017-.075.037-.15.055-.226.02-.076.037-.152.059-.227l.068-.224c.186-.596.429-1.175.71-1.735.281-.56.591-1.105.943-1.625h-.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212.816 95.474a5.174 5.174 0 0 0-.501-.634 4.34 4.34 0 0 0-.289-.28c-.1-.09-.206-.17-.315-.248a3.868 3.868 0 0 1 .553.57 4.865 4.865 0 0 1 .438.657l.115-.066h-.001ZM212.865 94.907a4.618 4.618 0 0 1 .53-.384 3.8 3.8 0 0 1 .287-.16c.098-.049.2-.092.305-.127-.108.026-.213.06-.316.1a4.105 4.105 0 0 0-.596.298 5.141 5.141 0 0 0-.282.182l.072.09v.001ZM213.062 93.657a5.212 5.212 0 0 1 .715-.644c.13-.095.266-.182.407-.26.142-.078.29-.143.444-.194-.156.043-.309.1-.456.17a4.127 4.127 0 0 0-.423.243 4.981 4.981 0 0 0-.761.617l.073.067h.001ZM213.005 90.3c.012.173.035.344.062.516a14.608 14.608 0 0 0 .203 1.02c.039.169.08.337.124.506l.064-.018a17.174 17.174 0 0 1-.376-1.51 6.81 6.81 0 0 1-.078-.513l.001-.001Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245.017 94.186c.478.873 2.325 2.109 3.166.77 1.047-1.668.438-3.147-.338-3.834-.867-.765-1.296 1.413-2.278-.08-1.735-2.636-1.935.614-.549 3.144h-.001Z",
  fill: "#5EB85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294.996 97.343h-444.344v86.185h444.344V97.343Z",
  fill: "#D7E8B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m136.854 97.155-59.159.206c75.143.989 174.49 1.252 217.301 6.439v-6.458l-15.052-.713-6.183-.162s-5.457-.021-7.274.094c-1.82.114-19.771-.075-19.771-.075s-7.341-.182-8.707-.205c-1.365-.023-11.938-.258-17.014-.187-5.073.072-10.41-.056-14.836.054-4.424.11-14.133-.069-17.281-.141-3.149-.073-18.494.255-20.05.317-1.558.063-7.472-.31-10.746-.176-3.274.133-21.229 1.007-21.229 1.007h.001ZM-4.831 97.155l54.066.206c-68.675.989-159.471 1.252-198.596 6.439v-6.458l13.755-.713 5.65-.162s4.988-.021 6.649.094c1.663.114 18.069-.075 18.069-.075s6.71-.182 7.958-.205c1.247-.023 10.91-.258 15.548-.187 4.636.072 9.515-.056 13.56.054 4.043.11 12.915-.069 15.793-.141 2.878-.073 16.902.255 18.323.317 1.424.063 6.83-.31 9.821-.176 2.992.133 19.402 1.007 19.402 1.007h.002Z",
  fill: "#A7D887"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-149.348 137.067s277.859-17.871 310.206-21.664c21.044-2.468 40.135-3.455 18.542-5.476-22.567-2.114-66.491-5.281-66.491-5.281l4.133-2.136s70.008 1.249 99.079 3.824c21.233 1.881 26.93 5.657 30.578 8.62 9.28 7.537 48.296 46.075 48.296 46.075v39.498h-444.356l.013-63.46Z",
  fill: "#fff"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "m170.973 157.381 8.109.746a2.96 2.96 0 0 0 1.919-.488l3.209-2.149c.147-.098.082-.327-.094-.333l-9.136-.337-4.11 1.982c-.278.134-.204.551.103.579Z",
  fill: "#0C3A24"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "m171.77 156.23 7.332.582 3.866-1.673-7.642-.752-3.556 1.843Z",
  fill: "#0C1B24"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M175.325 138.109h3.964v-35.651h-3.964v35.651Z",
  fill: "#BDC7D8"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M182.969 154.69v-48.535a3.688 3.688 0 0 0-3.679-3.697 3.688 3.688 0 0 0-3.679 3.697v47.38l3.393 2.861 3.965-1.706Z",
  fill: "#C9CCD4"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M179.004 156.396v-50.241a3.688 3.688 0 0 0-3.679-3.697 3.688 3.688 0 0 0-3.679 3.697v49.668l7.358.573Z",
  fill: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M175.248 105.513h.981l-1.482 2.842.418-2.192-1.015.011 1.495-2.689-.397 2.028Z",
  fill: "#FF3F43"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M175.268 114.815a.733.733 0 0 0 .731-.734v-4.105a.733.733 0 0 0-.731-.735.733.733 0 0 0-.731.735v4.105c0 .405.327.734.731.734Z",
  fill: "#0C2635"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M175.471 110.391c.004.183-.102.334-.237.337-.136.003-.248-.144-.251-.327-.004-.184.102-.334.237-.337.136-.003.248.144.251.327ZM175.471 111.545c.004.184-.102.334-.237.337-.136.003-.248-.144-.251-.327-.004-.183.102-.334.237-.337.136-.003.248.144.251.327ZM175.471 112.7c.004.183-.102.333-.237.336-.136.003-.248-.143-.251-.327-.004-.183.102-.333.237-.336.136-.003.248.143.251.327ZM175.471 113.854c.004.183-.102.334-.237.337-.136.003-.248-.144-.251-.327-.004-.184.102-.334.237-.337.136-.003.248.144.251.327Z",
  fill: "#29FF73"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M175.196 122.517c1.355-.027 2.423-1.539 2.386-3.376-.037-1.837-1.164-3.304-2.519-3.277-1.354.027-2.422 1.539-2.385 3.376.036 1.837 1.164 3.304 2.518 3.277Z",
  fill: "#000"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M175.182 121.795c1.06-.021 1.897-1.204 1.868-2.643-.029-1.438-.912-2.587-1.972-2.566-1.06.022-1.897 1.205-1.868 2.644.029 1.438.912 2.587 1.972 2.565Z",
  fill: "#0C2635"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M175.13 120.568c.566-.012 1.012-.643.997-1.41-.016-.767-.487-1.38-1.052-1.368-.566.011-1.012.642-.996 1.409.015.767.486 1.38 1.051 1.369Z",
  fill: "#000"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M174.763 120.583c.566-.012 1.012-.643.996-1.41-.015-.767-.486-1.379-1.051-1.368-.566.011-1.012.643-.997 1.41.016.767.487 1.379 1.052 1.368Z",
  fill: "#29FF73"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M174.723 120.369c.478-.01.855-.543.842-1.191-.013-.648-.411-1.166-.889-1.156-.478.009-.855.542-.842 1.191.013.648.411 1.165.889 1.156Z",
  fill: "#000F1F"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M174.695 120.216c.419-.009.749-.476.737-1.043-.011-.568-.359-1.021-.778-1.013-.418.008-.748.476-.737 1.043.011.568.36 1.021.778 1.013Z",
  fill: "#231F20"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M175.196 130.59c1.355-.028 2.423-1.539 2.386-3.376-.037-1.837-1.164-3.304-2.519-3.277-1.354.027-2.422 1.539-2.385 3.376.036 1.837 1.164 3.304 2.518 3.277Z",
  fill: "#000"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M175.182 129.868c1.06-.021 1.897-1.205 1.868-2.643-.029-1.439-.912-2.587-1.972-2.566-1.06.021-1.897 1.205-1.868 2.643.029 1.439.912 2.588 1.972 2.566Z",
  fill: "#0C2635"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M175.13 128.641c.566-.012 1.012-.643.997-1.41-.016-.767-.487-1.379-1.052-1.368-.566.012-1.012.643-.996 1.41.015.767.486 1.379 1.051 1.368Z",
  fill: "#000"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M174.763 128.656c.566-.011 1.012-.642.996-1.41-.015-.767-.486-1.379-1.051-1.368-.566.012-1.012.643-.997 1.41.016.767.487 1.379 1.052 1.368Z",
  fill: "#29FF73"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M174.723 128.442c.478-.01.855-.543.842-1.191-.013-.648-.411-1.166-.889-1.156-.478.009-.855.543-.842 1.191.013.648.411 1.165.889 1.156Z",
  fill: "#000F1F"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M174.695 128.289c.419-.008.749-.475.737-1.043-.011-.568-.359-1.021-.778-1.013-.418.009-.748.476-.737 1.043.011.568.36 1.022.778 1.013Z",
  fill: "#231F20"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M159.041 156.311c.36.041.808.326-1.52.907-12.508 3.124-46.163 10.439-58.982 13.11-15.6 3.251-26.773 3.558-39.658 3.558-12.884 0-51.493-3.227-57.346-4.15-5.853-.922 5.86-4.276 21.139-6.487 16.169-2.34 83.143-10.622 83.143-10.622s51.212 3.454 53.224 3.684Z",
  fill: "#0C3A24"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.59,
  d: "M151.516 156.376c.295.034.664.273-1.249.761-10.281 2.622-37.941 8.761-48.477 11.003-12.823 2.728-22.006 2.986-32.596 2.986-10.59 0-44.471-2.272-49.281-3.046-4.81-.774 6.87-4.752 19.523-5.881 12.652-1.129 68.335-8.914 68.335-8.914s42.091 2.898 43.745 3.091Z",
  fill: "#0C1B24"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "m140.264 145.602-12.304 5.945-28.2 5.381-19.998-.674-32.285-1.62 9.404-24.382 82.102 2.135s.354 2.637 1.158 5.781c.805 3.143.123 7.434.123 7.434Z",
  fill: "#151717"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "m138.821 145.602-12.304 5.945-28.2 5.381-19.998-.674-32.286-1.62 9.405-24.382 82.102 2.135s.353 2.637 1.158 5.781c.805 3.143.123 7.434.123 7.434Z",
  fill: "#151717"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M83.866 167.982c3.572 0 6.468-6.619 6.468-14.784 0-8.164-2.896-14.783-6.468-14.783s-6.468 6.619-6.468 14.783c0 8.165 2.896 14.784 6.468 14.784Z",
  fill: "#0C2635"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M83.867 138.415h8.126l.154 29.931-8.28-.364v-29.567Z",
  fill: "#0C2635"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M92.146 168.346c3.711 0 6.72-6.7 6.72-14.966 0-8.265-3.009-14.965-6.72-14.965-3.71 0-6.718 6.7-6.718 14.965 0 8.266 3.008 14.966 6.718 14.966Z",
  fill: "#0C2635"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M92.579 164.839c2.735 0 4.952-5.13 4.952-11.458 0-6.329-2.217-11.459-4.952-11.459s-4.952 5.13-4.952 11.459c0 6.328 2.217 11.458 4.952 11.458Z",
  fill: "#BDC7D8"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M92.685 163.696c2.407 0 4.359-4.618 4.359-10.316 0-5.697-1.952-10.315-4.36-10.315-2.406 0-4.358 4.618-4.358 10.315 0 5.698 1.952 10.316 4.359 10.316Z",
  fill: "#0C2635"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "m93.287 142.283-.879 9.334 4.478-3.38.344 1.977-4.651 3.552 3.754 6.345-.575 1.734-3.904-6.525-1.52 8.002-.824-1.441 1.437-8.136-3.142-2.307.26-2.335 3.064 2.36.864-9.3 1.294.12Z",
  fill: "#BDC7D8"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M90.422 153.38c0 1.832.641 3.316 1.433 3.316.79 0 1.432-1.484 1.432-3.316 0-1.831-.641-3.315-1.433-3.315-.79 0-1.432 1.484-1.432 3.315Z",
  fill: "#BDC7D8"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M90.627 153.38c0 .873.306 1.58.683 1.58.377 0 .683-.707.683-1.58 0-.872-.306-1.58-.683-1.58-.377 0-.683.708-.683 1.58ZM29.16 164.842c5.462 0 9.89-6.081 9.89-13.582s-4.428-13.581-9.89-13.581c-5.461 0-9.889 6.08-9.889 13.581 0 7.501 4.428 13.582 9.89 13.582Z",
  fill: "#0C2635"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M29.055 137.679h5.936l-.678 27.593-5.258-.43v-27.163Z",
  fill: "#0C2635"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M34.468 165.265c5.258 0 9.52-6.155 9.52-13.749 0-7.593-4.262-13.748-9.52-13.748-5.257 0-9.519 6.155-9.519 13.748 0 7.594 4.262 13.749 9.52 13.749Z",
  fill: "#0C2635"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M35.082 162.043c3.875 0 7.017-4.713 7.017-10.527 0-5.813-3.142-10.526-7.017-10.526-3.874 0-7.016 4.713-7.016 10.526 0 5.814 3.142 10.527 7.016 10.527Z",
  fill: "#F0F2F8"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M35.232 160.993c3.411 0 6.176-4.243 6.176-9.476 0-5.234-2.765-9.477-6.176-9.477-3.41 0-6.175 4.243-6.175 9.477 0 5.233 2.765 9.476 6.175 9.476Z",
  fill: "#0C2635"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "m36.086 141.322-.715 8.575 5.815-3.106.486 1.816-6.06 3.264 4.79 5.829-.816 1.593-5-5.995-2.685 7.352-1.167-1.324 2.567-7.475-4.983-2.119.369-2.145 4.87 2.168.695-8.544 1.834.111Z",
  fill: "#F0F2F8"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M32.467 151.516c0 1.683.909 3.046 2.03 3.046 1.12 0 2.03-1.363 2.03-3.046 0-1.682-.91-3.045-2.03-3.045-1.121 0-2.03 1.363-2.03 3.045Z",
  fill: "#A6B3C6"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M33.15 151.517c0 .801.433 1.452.968 1.452.535 0 .968-.65.968-1.452 0-.802-.433-1.453-.968-1.453-.534 0-.968.651-.968 1.453Z",
  fill: "#F0F2F8"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M36.212 117.296c.894.566.814 2.72 1.417 3.969 0 0 1.031.786.612 1.382-.23.328-.606.575-1.04.493-.276-.053-.728-.507-.997-.84a21.371 21.371 0 0 1-3.403-.811c-1.43-.486-2.116-2.927-1.606-4.212.42-1.058 3.653-.844 5.017.02v-.001Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "d",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 31,
  y: 116,
  width: 8,
  height: 8
}, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M36.212 117.296c.894.566.814 2.72 1.417 3.969 0 0 1.031.786.612 1.382-.23.328-.606.575-1.04.493-.276-.053-.728-.507-.997-.84a21.371 21.371 0 0 1-3.403-.811c-1.43-.486-2.116-2.927-1.606-4.212.42-1.058 3.653-.844 5.017.02v-.001Z",
  fill: "#fff"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#d)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M36.366 116.896c.494 2.421 1.548 4.866-1.762 3.819-1.783-.564-2.447-1.109-3.377-2.835-.741-1.374-.982-3.328-.982-3.328l-.323 7.067 7.532 1.89.786-.554-.663-1.212.043-1.028-1.254-3.818v-.001Z",
  fill: "#231F20"
}))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M125.354 147.252c0 6.254 2.009 11.324 4.487 11.324 2.477 0 4.487-5.07 4.487-11.324s-2.009-11.324-4.487-11.324-4.487 5.07-4.487 11.324Z",
  fill: "#0C2635"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M129.84 135.928h5.638l.106 22.928-5.744-.28v-22.648Z",
  fill: "#0C2635"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M130.924 147.392c0 6.331 2.087 11.464 4.661 11.464 2.574 0 4.661-5.133 4.661-11.464 0-6.33-2.087-11.463-4.661-11.463-2.574 0-4.661 5.132-4.661 11.463Z",
  fill: "#0C2635"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M132.449 147.392c0 4.847 1.539 8.777 3.436 8.777s3.435-3.93 3.435-8.777c0-4.847-1.538-8.777-3.435-8.777-1.898 0-3.436 3.929-3.436 8.777Z",
  fill: "#BDC7D8"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M132.936 147.392c0 4.364 1.354 7.902 3.024 7.902s3.024-3.538 3.024-7.902c0-4.364-1.354-7.901-3.024-7.901-1.671 0-3.024 3.537-3.024 7.901Z",
  fill: "#0C2635"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "m136.375 138.892-.609 7.15 3.107-2.59.238 1.514-3.227 2.722 2.605 4.86-.399 1.328-2.708-4.998-1.055 6.13-.572-1.105.998-6.232-2.181-1.767.18-1.788 2.127 1.808.599-7.124.897.092Z",
  fill: "#BDC7D8"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M134.389 147.393c0 1.402.445 2.539.994 2.539.549 0 .994-1.137.994-2.539 0-1.403-.445-2.54-.994-2.54-.549 0-.994 1.137-.994 2.54Z",
  fill: "#BDC7D8"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M134.531 147.392c0 .669.213 1.211.474 1.211.262 0 .474-.542.474-1.211s-.212-1.211-.474-1.211c-.261 0-.474.542-.474 1.211Z",
  fill: "#0C2635"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "m140.264 145.601.026-2.642s-.248-9.851-4.243-9.639c-3.281.174-4.663 4.253-5.677 8.766-.853 3.796-1.422 9.512-3.497 9.829-4.463.685-9.854 1.62-14.484 2.322-4.577.695-12.002 2.691-12.002 2.691.679-7.839-.69-23.695-7.426-23.348-6.226.321-8.44 12.021-9.584 25.275-1.388.788-13.894 1.457-19.6 1.457-6.088 0-35.072-.949-38.684-1.388-3.611-.44-6.19-.634-8.006-4.6-2.979-6.51-2.726-12.515-2.183-14.842.993-4.253 2.073-11.848 17.615-17.707.522-.197 3.226-.042 3.8-.173 11.656-10.676 24.435-18.965 34.926-20.397 10.223-1.396 26.788-2.09 39.072-2.604 8.289-.347 16.473 4.166 23.466 12.499a141.091 141.091 0 0 0 4.25 3.254s3.216 13.736 3.799 14.777c.741 1.323-.086 14.95-1.568 16.469v.001Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "e",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 14,
  y: 98,
  width: 129,
  height: 63
}, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "m140.264 145.601.026-2.642s-.248-9.851-4.243-9.639c-3.281.174-4.663 4.253-5.677 8.766-.853 3.796-1.422 9.512-3.497 9.829-4.463.685-9.854 1.62-14.484 2.322-4.577.695-12.002 2.691-12.002 2.691.679-7.839-.69-23.695-7.426-23.348-6.226.321-8.44 12.021-9.584 25.275-1.388.788-13.894 1.457-19.6 1.457-6.088 0-35.072-.949-38.684-1.388-3.611-.44-6.19-.634-8.006-4.6-2.979-6.51-2.726-12.515-2.183-14.842.993-4.253 2.073-11.848 17.615-17.707.522-.197 3.226-.042 3.8-.173 11.656-10.676 24.435-18.965 34.926-20.397 10.223-1.396 26.788-2.09 39.072-2.604 8.289-.347 16.473 4.166 23.466 12.499a141.091 141.091 0 0 0 4.25 3.254s3.216 13.736 3.799 14.777c.741 1.323-.086 14.95-1.568 16.469v.001Z",
  fill: "#fff"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M29.842 120.822c-14.851 4.339-7.326 9.03 4.317 9.027 24.487-.008 52.412-9.722 52.412-9.722l-56.73.695Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M82.598 161.702s-.26-13.019 2.159-20.917c1.792-5.857 4.463-9.651 8.807-9.722 5.354-.086 9.757 13.454 6.735 26.126-.983 4.121-17.701 4.513-17.701 4.513ZM127.891 153.431s.817-10.63 2.292-15.169c1.295-3.98 3.443-6.671 6.274-6.721 3.488-.062 5.531 9.884 3.561 18.964-.64 2.954-12.127 2.926-12.127 2.926Z",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "m91.69 120.995 39.652-8.137 2.59-1.628 4.274 2.995c-.303.561-2.433 2.138-3.821 2.538-8.807 2.539-28.96 5.647-36.265 6.705l-1.695-1.726-2.475.296 1.814 1.748c-7.018.879-15.315 1.292-4.074-2.792v.001Z",
  fill: "#fff"
}))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M116.109 148.398c-5.729.98-13.715 2.607-12.007 3.221 1.706.614 8.672-.998 13.209-1.945 10.829-2.26 15.869-4.196-1.201-1.276h-.001Z",
  fill: "#fff"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M81.91 161.157c.842-.521 1.306-1.259 1.468-2.301 0 0-13.473 1.664-14.657.882-3.783-2.494-9.047-7.28-18.068-7.572-4.574-.148-28.84-1.042-31.689-.912-2.85.13.06 9.492 2.787 9.83 6.837.847 30.998 1.996 37.043 1.822 5.96-.171 23.116-1.75 23.116-1.75v.001Z",
  fill: "#0C2635"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m133.626 118.826-3.433.969.217-.889 3.433-.969-.217.889Z",
  fill: "#fff"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m133.597 118.682-3.433.97.217-.889 3.432-.97-.216.889Z",
  fill: "#0C2635"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m119.013 122.496-4.765.885.324-.996 4.765-.885-.324.996Z",
  fill: "#fff"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m118.992 122.33-4.765.886.323-.997 4.766-.886-.324.997Z",
  fill: "#0C2635"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.07,
  d: "M100.284 131.037c1.527 6.623 2.449 18.623 4.852 18.301 2.914-.391 17.636-3.151 19.535-3.671 1.9-.521 4.264-10.396 5.85-14.43 1.468-3.732 6.563-11.891 9.843 7.638.404 2.402.549-4.932.346-7.551-.431-5.555-1.925-8.075-16.622-6.713-5.333.495-24.694 2.573-23.804 6.426ZM82.447 136.478c1.21-2.641-2.504-2.621-11.073 3.395-5.255 3.689-11.375 7.691-8.321 10.188 2.46 2.012 7.382 4.821 10.885 4.654 3.504-.168 4.021-2.01 4.38-3.647.458-2.096 2.919-11.949 4.128-14.59ZM25.782 138.272c3.821-.069 11.337.225 15.841.357 5.746.167 10.21 1.793 14.205 5.299 2.006 1.761-6.115 2.787-14.715 2.706-5.591-.052-12.276-.322-16.102-.596-3.822-.273-8.182-.108-7.256-2.354.774-1.878 3.069-5.322 8.027-5.412Z",
  fill: "#231F20"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "M34.204 121.776c12.606.217 42.914-.607 52.368-1.649 5.958-9.548 12.52-20.093 23.745-21.525-16.405.26-30.547 1.03-39.2 1.953-8.549.911-24.869 10.025-36.914 21.221Z",
  fill: "#0C2635"
})), /*#__PURE__*/React.createElement("mask", {
  id: "f",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 34,
  y: 98,
  width: 77,
  height: 24
}, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M34.202 121.776c12.606.217 42.913-.607 52.368-1.649 5.958-9.548 12.52-20.093 23.745-21.525-16.405.26-30.547 1.03-39.2 1.953-8.549.911-24.869 10.025-36.914 21.221Z",
  fill: "#fff"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.98 122.167c24.22-17.446 65.191-21.612 75.38-23.695-16.405.26-25.272.725-33.933 1.563-13.02 1.258-29.401 10.936-41.447 22.132Z",
  fill: "#5B6F80"
}))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "M129.011 148.856s-7.204 1.688-13.859 3.082c-6.216 1.301-9.498 2.213-14.657 3.515-.216.52-.712 1.345-.712 1.345l-.084.543s13.403-2.942 17.55-3.537c7.858-1.128 10.07-1.279 10.683-1.909.613-.631 1.079-3.038 1.079-3.038v-.001ZM91.691 120.995c17.529-1.562 37.678-6.017 40.3-6.77 1.057-.303 1.103-.911 1.535-2.734-6.476-7.811-16.387-11.066-21.222-10.545-13.47 1.45-20.612 20.049-20.612 20.049Z",
  fill: "#0C2635"
})), /*#__PURE__*/React.createElement("mask", {
  id: "g",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 91,
  y: 100,
  width: 43,
  height: 21
}, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  d: "M91.69 120.995c17.528-1.562 37.677-6.017 40.299-6.77 1.057-.303 1.103-.911 1.535-2.734-6.476-7.811-16.387-11.066-21.222-10.545-13.47 1.45-20.612 20.049-20.612 20.049Z",
  fill: "#fff"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#g)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M92.012 119.953s9.507-11.801 23.4-12.151c10.877-.274 18.113 3.141 18.113 3.141s-.585-12.862-13.537-12.862c-12.952 0-22.104 2.951-24.35 7.117-2.244 4.166-3.626 14.755-3.626 14.755Z",
  fill: "#5B6F80"
}))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  d: "M113.364 100.893c-.376 0-.731.018-1.062.053-13.47 1.451-20.613 20.05-20.613 20.05 17.529-1.563 37.678-6.017 40.3-6.77 1.057-.304 1.103-.912 1.535-2.735-6.032-7.276-15.045-10.599-20.16-10.599v.001Zm18.667 12.136c-.039.07-.067.12-.328.195-1.241.357-6.932 1.661-14.463 3.059-6.157 1.143-15.139 2.645-23.902 3.511.8-1.734 2.295-4.674 4.446-7.67 1.954-2.72 4.053-4.942 6.239-6.603 2.683-2.038 5.506-3.229 8.389-3.54.294-.031.614-.047.952-.047 2.615 0 6.001.9 9.291 2.47 2.66 1.269 6.47 3.566 9.74 7.361-.135.585-.244 1.046-.364 1.263v.001Z",
  fill: "#0C2635"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  d: "M21.715 134.303s5.138.81 10.752.844c7.127.044 18.117-.694 18.117-.694l3.05-4.58s-11.962 1.381-20.84 1.293c-7.183-.072-9.888-1.071-9.888-1.071l-1.191 4.208Z",
  fill: "#231F20",
  opacity: 0.07
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  d: "M34.417 133.864c.617-.601.754-1.464.307-1.927-.447-.464-1.31-.352-1.926.249-.617.602-.754 1.465-.307 1.928.447.463 1.31.351 1.926-.25Z",
  fill: "#0C2635"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  d: "m113.404 100.946 3.976 16.37 2.821 2.548c.453 9.894.416 19.962-.969 26.584-.321 1.534 1.295 2.669 1.295 2.669s-.129 3.793-2.59 4.509M129.801 107.792l2.188 6.433 2.396 2.539s.349 6.357.097 8.236c-.251 1.879.495 3.314.616 4.448.284 2.657.085 4.023.085 4.023M95.361 120.631l2.76 2.838c3.368 9.179 4.685 23.277 5.117 25.821.273 1.613.906 2.821.906 2.821s.36 3.577-2.008 4.664M72.893 126.626s13.555-4.329 18.798-5.63",
  stroke: "#B1B1B1",
  strokeWidth: 0.25,
  strokeLinejoin: "round"
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  d: "M86.572 120.127c1.123 1.042 1.209 1.91 1.209 1.91M72.893 126.626s6.988 3.626 10.182 5.175c2.855 1.385 4.505 2.764 4.505 2.764l1.304 1.363",
  stroke: "#B1B1B1",
  strokeWidth: 0.25,
  strokeLinejoin: "round"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  d: "M49.822 135.583c.794-1.438 2.699-4.449 3.811-5.71 3.473-.437 15.616-2.297 19.258-3.282-1.49 2.792-2.232 3.631-4.3 4.468-3.593 1.452-10.52 3.278-18.769 4.524ZM21.715 135.15c-1.878-.193-4.086-1.552-3.973-2.929.173-2.093 3.235-4.024 3.235-4.024-.25.15.219 1.427 2.145 1.965-.595 1.356-1.07 3.709-1.407 4.988Z",
  fill: "#C9CCD4"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  d: "M98.754 116.157c-1.368.611-2.943 3.037-3.868 4.388 0 0-1.577.849-.936 1.494.353.355.928.622 1.591.533.423-.057 1.117-.548 1.528-.908 2.04-.207 4.22-.639 5.21-.877 2.189-.526 3.176-2.98 3.161-4.511-.01-1.097-4.596-1.053-6.686-.119Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "h",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 93,
  y: 115,
  width: 13,
  height: 8
}, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  d: "M98.756 116.157c-1.368.611-2.943 3.037-3.868 4.388 0 0-1.577.849-.936 1.494.353.355.928.622 1.591.533.423-.057 1.116-.548 1.528-.908 2.04-.207 4.22-.639 5.21-.877 2.189-.526 3.176-2.98 3.161-4.511-.01-1.097-4.597-1.053-6.686-.119Z",
  fill: "#fff"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#h)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.07,
  d: "M98.152 116.427c-1.96 2.743-3.702 4.656 1.368 3.524 2.728-.609 3.745-1.199 5.17-3.065 1.135-1.485 1.503-3.598 1.503-3.598l.495 7.641-11.532 2.043-1.205-.599 1.017-1.311-.066-1.111 3.25-3.524Z",
  fill: "#231F20"
}))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  d: "M174.414 118.217c.368-.115.842.133.945.727.141.824-.295 1.181-.768 1.355-.473.174-1.125.578-1.178.854-.02.101-.092 1.054-.263 1.936-.062.322-.431 1.574-.518 1.703-.087.128-.361.297-.526.271-.166-.025-.67-1.311-.517-2.992.153-1.68.243-1.776.193-1.955-.05-.18-.538-.375.185-.747.308-.158 1.452-.838 2.447-1.152Z",
  fill: "#0C2635"
})), /*#__PURE__*/React.createElement("mask", {
  id: "i",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 171,
  y: 118,
  width: 5,
  height: 8
}, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  d: "M174.414 118.218c.368-.115.842.133.945.727.141.823-.295 1.181-.768 1.355-.473.173-1.125.577-1.178.854-.02.1-.092 1.054-.263 1.936-.062.321-.431 1.574-.518 1.702-.087.129-.361.298-.526.272-.166-.026-.67-1.312-.517-2.992.153-1.681.243-1.776.193-1.956-.05-.179-.538-.374.185-.746.308-.158 1.452-.839 2.447-1.152Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#i)"
}, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  d: "M171.714 120.191s.346-.088.444-.269c.098-.182.49-.352.943-.554.448-.199 2.077-1.048 2.077-1.048s-.639-.467-.771-.45c-.132.016-3.081 1.649-3.081 1.649l.118.231.27.441Z",
  fill: "#BBBDBF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M175.58 118.98s-1.8.966-2.253 1.308c-.453.342-.539.705-.576.969-.089.639-.27 3.236-.28 3.353-.01.116.411.206.411.206l.837-3.677 1-.714s.81-.404.826-.636c.017-.231.035-.808.035-.808v-.001Z",
  fill: "#0C1B24",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.5
}), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M171.758 119.337s-.107.279.443.134c.549-.144 2.834-1.274 2.834-1.274s-.502-.239-.858-.083c-.355.156-2.419 1.224-2.419 1.224v-.001Z",
  fill: "#fff"
})), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M172.222 120.051c.026.079-.117.197-.32.265s-.388.06-.415-.019c-.026-.079.118-.197.32-.265.203-.068.389-.06.415.019Z",
  fill: "#0C1B24"
})), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M171.66 120.989c.089-.36.37-.58.4-.275.031.304.001 3.681-.093 4.037-.038.146-.245.194-.282.049-.18-.711-.344-2.7-.274-3.132.07-.432.249-.679.249-.679Z",
  fill: "#fff"
}))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
  d: "m171.822 120.736.142-.007c.1-.003.176-.12.17-.26-.006-.141-.092-.253-.192-.25l-.142.007h-.001c-.1.003-.176.119-.17.26.007.141.092.253.193.25Z",
  fill: "#29FF73"
})), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
  d: "m171.966 120.729-.143.007c.1-.003.177-.12.17-.261-.006-.141-.092-.253-.192-.25l.142-.007c.1-.003.186.109.193.25.006.141-.07.258-.17.261Z",
  fill: "#0C1B24",
  opacity: 0.1
})), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
  d: "m172.63 125.507.155-.912c.016-.09-.211-.173-.507-.184-.295-.012-.527.052-.518.143l.09.922c.008.091.181.171.384.18.203.008.381-.059.396-.149Z",
  fill: "#1D3439"
})), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
  d: "m172.785 124.594-.155.913c.015-.091-.157-.171-.384-.18-.228-.009-.405.057-.396.149l-.09-.922c-.009-.092.223-.156.518-.144.295.012.522.094.507.184Z",
  fill: "#0C1B24",
  opacity: 0.2
})), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
  d: "m135.392 118.089.128 3.116a.451.451 0 0 0 .571.417l1.742-.492a.803.803 0 0 0 .583-.822l-.191-3.23a.38.38 0 0 0-.514-.335l-1.91.723a.638.638 0 0 0-.41.623h.001Z",
  fill: "#000F1F"
})), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
  d: "m135.453 118.476.11 2.654c.01.248.248.422.486.354l1.485-.418a.686.686 0 0 0 .496-.701l-.162-2.751a.325.325 0 0 0-.438-.286l-1.627.616a.543.543 0 0 0-.349.531l-.001.001Z",
  fill: "#0C2635"
})), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
  d: "M136.986 120.841c.375-.093.528-.786.342-1.547-.187-.761-.642-1.303-1.018-1.21-.375.093-.528.785-.341 1.546.186.762.642 1.304 1.017 1.211Z",
  fill: "#000"
})), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
  d: "M137.23 120.788c.376-.093.529-.786.342-1.547-.187-.761-.642-1.303-1.017-1.21-.376.093-.529.785-.342 1.547.186.761.642 1.303 1.017 1.21Z",
  fill: "#29FF73"
})), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
  d: "M136.345 119.55c.157.643.542 1.101.859 1.022.316-.078.446-.663.288-1.307-.157-.643-.542-1.1-.859-1.022-.317.079-.446.663-.288 1.307Z",
  fill: "#000F1F"
})), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
  d: "M137.181 120.412c.277-.069.391-.581.253-1.145-.139-.563-.476-.964-.753-.895-.278.069-.391.581-.253 1.145.138.563.475.964.753.895Z",
  fill: "#000"
})), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
  d: "M136.906 118.471c-.355.061-.554.473-.387 1.012.232.748.658.858 1.126.799.468-.059 1.728-.283 1.89-.075.059.075.37.919.887 1.581.189.241 1.03 1.126 1.157 1.196.127.07.427.092.554 0 .127-.093 0-1.382-.843-2.717-.844-1.335-.959-1.376-.994-1.547-.034-.171.289-.543-.471-.542-.325 0-1.956.125-2.92.293h.001Z",
  fill: "#0C2635"
})), /*#__PURE__*/React.createElement("mask", {
  id: "j",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 136,
  y: 118,
  width: 7,
  height: 6
}, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
  d: "M136.906 118.471c-.355.061-.554.473-.387 1.012.232.748.658.858 1.126.799.468-.059 1.728-.283 1.89-.075.059.075.37.919.887 1.581.189.241 1.03 1.126 1.157 1.196.127.07.427.092.554 0 .127-.093 0-1.382-.843-2.717-.844-1.335-.959-1.376-.994-1.547-.034-.171.289-.543-.471-.542-.325 0-1.956.125-2.92.293h.001Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#j)"
}, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
  d: "M140.384 118.754s-.326.076-.486-.034c-.159-.109-.558-.082-1.02-.056-.459.027-2.567.22-2.567.22s.333-.664.45-.707c.117-.043 3.659-.151 3.659-.151v.244l-.036.484Z",
  fill: "#BBBDBF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M136.258 119.608s2.495-.27 3.018-.179c.522.091.749.355.892.56.347.493 1.409 2.681 1.467 2.774.058.093-.255.349-.255.349l-2.263-2.706-1.526.036s-.848.011-.96-.175c-.112-.186-.373-.659-.373-.659Z",
  fill: "#0C1B24",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.5
}), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M139.985 118.062s.208.186-.312.302c-.52.116-3.294.356-3.294.356s.317-.414.68-.438c.362-.023 2.926-.22 2.926-.22Z",
  fill: "#fff"
})), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M139.901 118.856c.012.077.182.115.38.084s.349-.118.337-.195c-.011-.076-.182-.114-.38-.084-.197.031-.349.118-.337.195Z",
  fill: "#0C1B24"
})), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M140.769 119.395c-.227-.262-.554-.324-.45-.057.103.267 1.302 3.076 1.532 3.332.094.105.55.049.52-.087-.153-.67-.863-2.399-1.105-2.729-.243-.33-.497-.459-.497-.459Z",
  fill: "#fff"
}))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
  d: "M140.581 118.963c-.056-.119-.157-.19-.227-.157l-.163.076c-.069.033-.08.157-.024.277.056.119.157.19.226.157l.164-.077c.07-.032.081-.156.025-.276h-.001Z",
  fill: "#29FF73"
})), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
  d: "m140.393 119.317.164-.077c-.069.032-.171-.038-.227-.158-.056-.12-.045-.243.025-.276l-.164.077c-.069.033-.08.157-.024.276.056.12.157.191.226.158Z",
  fill: "#0C1B24",
  opacity: 0.1
})), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
  d: "M142.185 123.552c.186-.087.315-.229.288-.317v-.001l-.273-.892c-.027-.088-.267-.058-.538.068-.27.127-.449.292-.4.37l.497.788c.049.078.24.071.426-.016Z",
  fill: "#1D3439"
})), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
  d: "m141.262 122.78.497.789c-.049-.079.08-.22.288-.318.208-.097.399-.105.426-.016l-.273-.893c-.027-.088-.267-.058-.538.068-.27.127-.449.292-.4.37Z",
  fill: "#0C1B24",
  opacity: 0.2
})), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
  d: "M172.234 125.655c-1.332 24.982 9.041 33.201-10.387 33.201s-14.309-23.982-19.646-35.278",
  stroke: "#231F20",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
  d: "m135.918 117.137 1.97-.793a.489.489 0 0 0 .248-.191l1.713-2.16c.142-.197-.138-.418-.307-.435 0 0-2.341.649-2.491.705-.15.056-.327.234-.417.396l-1.15 2.063c-.153.256.268.471.433.415h.001Z",
  fill: "#0C2635"
})), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
  d: "m135.915 117.137 2.237-.759a.489.489 0 0 0 .248-.191l1.446-2.194c.097-.147-.04-.337-.209-.289l-2.321.658a.692.692 0 0 0-.418.331l-1.209 2.171c-.085.152.062.33.226.274v-.001Z",
  fill: "#000F1F"
})), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
  d: "m136.146 116.654 1.56-.436s.228.214.218.483c-.011.268-.35.419-.35.419l-1.556.524.32-.366.021-.301-.214-.323h.001Z",
  fill: "#000"
})), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
  d: "m136.146 116.654-.064.16.056.047a.35.35 0 0 1-.057.577l-.063.034v.172l.21-.119a.455.455 0 0 0 .069-.744l-.151-.126v-.001ZM138.285 115.735c.296-.46.304-.983.019-1.167-.285-.185-.755.038-1.05.498-.296.461-.304.984-.019 1.168.285.185.755-.038 1.05-.499Z",
  fill: "#0C2635"
})), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
  d: "M138.203 115.682c.249-.388.256-.828.016-.984-.24-.156-.637.032-.886.42-.248.388-.255.829-.015.984.24.156.636-.032.885-.42Z",
  fill: "#000F1F"
})), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
  d: "M138.287 115.737c.248-.388.266-.822.038-.97-.228-.147-.614.047-.863.435s-.266.822-.038.969c.227.148.614-.047.863-.434ZM174.41 126.53c.368-.115.842.133.945.727.142.824-.295 1.181-.768 1.355-.473.174-1.125.578-1.178.854-.019.101-.092 1.054-.263 1.936-.062.322-.431 1.574-.518 1.703-.087.128-.361.297-.526.271-.166-.025-.67-1.311-.517-2.992.153-1.68.243-1.776.193-1.955-.05-.18-.537-.375.185-.747.308-.158 1.452-.838 2.447-1.152Z",
  fill: "#0C2635"
})), /*#__PURE__*/React.createElement("mask", {
  id: "k",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 171,
  y: 126,
  width: 5,
  height: 8
}, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
  d: "M174.408 126.53c.368-.115.842.133.945.727.142.824-.295 1.181-.768 1.355-.473.174-1.125.578-1.178.854-.019.101-.092 1.054-.263 1.936-.062.322-.431 1.574-.518 1.703-.087.128-.361.297-.526.271-.166-.025-.67-1.311-.517-2.992.153-1.68.243-1.776.193-1.955-.05-.18-.537-.375.185-.747.308-.158 1.452-.838 2.447-1.152Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#k)"
}, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
  d: "M171.708 128.504s.346-.088.444-.269c.098-.182.49-.352.943-.554.448-.199 2.077-1.048 2.077-1.048s-.638-.467-.771-.45c-.132.016-3.081 1.649-3.081 1.649l.119.231.269.441Z",
  fill: "#BBBDBF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M175.575 127.293s-1.801.966-2.254 1.308c-.452.342-.538.705-.576.969-.089.639-.27 3.236-.28 3.353-.01.116.411.206.411.206l.837-3.677 1-.714s.81-.404.826-.636c.017-.231.036-.808.036-.808v-.001Z",
  fill: "#0C1B24",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.5
}), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M171.753 127.65s-.108.278.442.134c.55-.144 2.834-1.274 2.834-1.274s-.502-.239-.858-.083c-.355.156-2.418 1.224-2.418 1.224v-.001Z",
  fill: "#fff"
})), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M172.216 128.364c.026.079-.117.197-.32.265s-.388.06-.414-.019c-.026-.079.117-.197.32-.265.202-.068.388-.06.414.019Z",
  fill: "#0C1B24"
})), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M171.654 129.302c.089-.36.37-.58.401-.275.031.304.001 3.681-.094 4.037-.038.146-.245.194-.282.049-.18-.711-.344-2.7-.274-3.132.07-.432.249-.679.249-.679Z",
  fill: "#fff"
}))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
  d: "m171.816 129.05.142-.007c.1-.003.177-.12.17-.261-.006-.141-.092-.253-.192-.25l-.142.007h-.001c-.1.003-.176.12-.17.261.007.141.093.252.193.25Z",
  fill: "#29FF73"
})), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
  d: "m171.958 129.042-.142.007c.1-.003.176-.12.17-.261-.007-.141-.093-.252-.193-.249l.142-.007c.1-.003.187.109.193.25.006.14-.07.257-.17.26Z",
  fill: "#0C1B24",
  opacity: 0.1
})), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
  d: "m172.628 133.82.155-.912c.016-.09-.211-.173-.507-.184-.294-.012-.527.052-.518.143l.09.922c.009.091.181.171.384.18.203.008.381-.059.396-.149Z",
  fill: "#1D3439"
})), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
  d: "m172.785 132.907-.155.913c.015-.091-.157-.171-.384-.18-.228-.009-.405.057-.396.149l-.09-.922c-.009-.092.223-.156.518-.144.295.012.522.094.507.184Z",
  fill: "#0C1B24",
  opacity: 0.2
})), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M187.422 164.175a3.705 3.705 0 0 1 2.882-1.378h67.453a4.38 4.38 0 0 1 2.39.71c3.694 2.403 1.928 8.143-2.478 8.055l-67.439-1.355c-3.079-.062-4.743-3.636-2.808-6.032Z",
  fill: "#D9D9D9"
})), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M189.088 164.463a2.97 2.97 0 0 1 2.559-1.464h65.341a3.54 3.54 0 0 1 2.239.798c2.602 2.124 1.058 6.34-2.301 6.281l-65.331-1.143c-2.271-.04-3.657-2.513-2.507-4.472Z",
  fill: "#616C70"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#l)"
}, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
  d: "M223.937 168.616a.49.49 0 0 1-.624-.296l-2.242-6.271a.49.49 0 0 1 .921-.327l2.241 6.271a.488.488 0 0 1-.296.623Z",
  fill: "url(#m)"
})), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
  d: "m191.663 145.7 4.364-.923 1.095 2.105-5.451-.884c-.166-.027-.172-.263-.007-.298h-.001Z",
  fill: "url(#n)"
})), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
  d: "M246.998 144.711h-1.322v2.008h1.322v-2.008Z",
  fill: "url(#o)"
})), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
  d: "m247.531 158.4 2.053-2.292-4.56-4.066-2.053 2.292 4.56 4.066Z",
  fill: "#000"
})), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
  d: "m245.608 148.471-2.665 1.367 1.883 3.652 2.664-1.367-1.882-3.652Z",
  fill: "url(#p)"
})), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
  d: "M210.486 158.655h-12.453v1.481h12.453v-1.481Z",
  fill: "url(#q)"
})), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
  d: "m205.013 153.42-2.124-1.836-4.657 5.363 2.124 1.836 4.657-5.363Z",
  fill: "#000"
})), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
  d: "M210.071 156.979c.933 0 1.692.757 1.692 1.688v1.263c0 .931-.759 1.688-1.692 1.688h-12.158a1.692 1.692 0 0 1-1.693-1.688v-1.263c0-.931.759-1.688 1.693-1.688h12.158Zm0-.507h-12.158c-1.211 0-2.2.987-2.2 2.194v1.263c0 1.207.99 2.194 2.2 2.194h12.158c1.21 0 2.2-.987 2.2-2.194v-1.263c0-1.207-.99-2.194-2.2-2.194Z",
  fill: "#000"
})), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
  d: "M207.906 156.977h22.266c.933 0 1.689.755 1.689 1.684v1.973c0 .931-.757 1.685-1.689 1.685h-20.577a1.688 1.688 0 0 1-1.689-1.685v-3.657Z",
  fill: "url(#r)"
})), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
  d: "m236.278 129.349-2.132.689 2.231 6.873 2.132-.688-2.231-6.874Z",
  fill: "url(#s)"
})), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
  d: "M250.976 152.549c3.746 0 6.793 3.04 6.793 6.776 0 3.737-3.047 6.777-6.793 6.777-3.745 0-6.793-3.04-6.793-6.777 0-3.736 3.048-6.776 6.793-6.776Zm0-2.495c-5.133 0-9.294 4.151-9.294 9.272s4.161 9.272 9.294 9.272c5.134 0 9.295-4.151 9.295-9.272s-4.161-9.272-9.295-9.272Z",
  fill: "url(#t)"
})), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
  d: "M246.73 159.309a4.24 4.24 0 0 0 4.245 4.235 4.24 4.24 0 0 0 4.245-4.235c0-2.339-1.9-4.234-4.245-4.234a4.24 4.24 0 0 0-4.245 4.234Zm1.505-2.054a.114.114 0 1 1-.048-.224.114.114 0 0 1 .048.224Zm-.078 1.228a.115.115 0 1 1 .105.204.115.115 0 0 1-.105-.204Zm1.186 2.523a.115.115 0 0 1 .102.125.115.115 0 0 1-.228-.023.115.115 0 0 1 .126-.102Zm-.057-3.768a.115.115 0 1 1 .22.06.115.115 0 0 1-.22-.06Zm.25-1.402a.114.114 0 0 1-.224-.047.115.115 0 0 1 .224.047Zm.01 4.927a.114.114 0 0 1-.14.081.113.113 0 0 1-.081-.139.113.113 0 0 1 .14-.081.114.114 0 0 1 .081.14v-.001Zm1.256-3.974a.116.116 0 0 1-.162-.008.114.114 0 1 1 .17-.153.115.115 0 0 1-.008.161Zm1.043-.874a.114.114 0 0 1-.16-.026.114.114 0 0 1 .025-.159.115.115 0 0 1 .135.185Zm.273.752a.114.114 0 1 1-.07-.217.115.115 0 0 1 .144.074.112.112 0 0 1-.074.143Zm.046.399a.114.114 0 0 1-.131-.095.115.115 0 0 1 .095-.131.114.114 0 1 1 .036.226Zm1.008.649a.115.115 0 0 1-.083.214.115.115 0 0 1 .083-.214Zm.194-1.344a.115.115 0 0 1-.14-.081.112.112 0 0 1 .081-.139.114.114 0 0 1 .14.08.116.116 0 0 1-.081.141v-.001Zm.024.401a.115.115 0 0 1-.126-.102.113.113 0 0 1 .102-.125.115.115 0 0 1 .127.102.116.116 0 0 1-.103.126v-.001Zm1.207 3.274a.114.114 0 0 1 .161.017.114.114 0 0 1-.017.161.114.114 0 1 1-.144-.178Zm-.055-1.937a.113.113 0 0 1-.073-.143.114.114 0 1 1 .073.143Zm-.198.35a.114.114 0 0 1-.05-.154.114.114 0 1 1 .05.154Zm-.079 1.776a.114.114 0 1 1 .114.198.114.114 0 0 1-.114-.198Zm-.198-1.622a.114.114 0 1 1 .026.159.113.113 0 0 1-.026-.159Zm-.16 1.758a.115.115 0 0 1 .148.065.115.115 0 0 1-.214.083.114.114 0 0 1 .066-.148Zm-.111-1.489a.114.114 0 1 1 .161.162.114.114 0 0 1-.161-.162Zm-.227 2.978a.115.115 0 1 1 .024.228.115.115 0 0 1-.024-.228Zm-.037-1.411a.114.114 0 0 1 .136.088.114.114 0 0 1-.224.047.114.114 0 0 1 .088-.135Zm-.046-1.344a.113.113 0 0 1 .159.026.112.112 0 0 1-.025.159.114.114 0 1 1-.134-.185Zm-.135-1.934a.113.113 0 1 1 .012-.227.113.113 0 0 1 .108.119.113.113 0 0 1-.12.108Zm-.101.389a.115.115 0 0 1-.088-.136.114.114 0 1 1 .088.136Zm-.002 1.921a.115.115 0 1 1-.104-.205.115.115 0 0 1 .104.205Zm-.181 2.465a.114.114 0 1 1 .228.012.114.114 0 0 1-.228-.012Zm-.025-1.359a.114.114 0 1 1 .228-.012.114.114 0 0 1-.228.012Zm-.169-2.321a.113.113 0 0 1-.041-.156.114.114 0 1 1 .198.114.116.116 0 0 1-.157.042Zm-.196 3.579a.114.114 0 0 1 .224.047.114.114 0 0 1-.135.088.114.114 0 0 1-.089-.135Zm-.033-1.318a.115.115 0 0 1 .229.024.115.115 0 0 1-.229-.024Zm-.336 1.157a.114.114 0 0 1 .148-.065.114.114 0 1 1-.082.213.115.115 0 0 1-.066-.148Zm-.162-4.218a.115.115 0 0 1-.115-.114c0-.063.052-.114.115-.114a.114.114 0 1 1 0 .228Zm-.177 4.002a.114.114 0 1 1 .198.114.114.114 0 0 1-.198-.114Zm-.112-5.239a.115.115 0 1 1 .154.05.116.116 0 0 1-.154-.05Zm-.173 5.134a.114.114 0 1 1 .144-.178.114.114 0 0 1-.144.178Zm-.122 1.509a.115.115 0 0 1 .205.104.116.116 0 0 1-.155.05.114.114 0 0 1-.05-.154Zm-.101-7.294a.113.113 0 0 1 0-.161.114.114 0 1 1 0 .161Zm-.214 7.043a.115.115 0 0 1 .186.134.114.114 0 0 1-.16.026.114.114 0 0 1-.026-.16Zm-.271-.296a.116.116 0 0 1 .162 0 .116.116 0 0 1 0 .162.116.116 0 0 1-.162 0 .114.114 0 0 1 0-.162Zm-.129-5.225a.115.115 0 0 1 .034-.158.115.115 0 0 1 .158.034.115.115 0 0 1-.034.158.115.115 0 0 1-.158-.034Zm-.093 4.89a.115.115 0 0 1 .135.185.114.114 0 0 1-.16-.026.114.114 0 0 1 .025-.159Zm-.166-.365a.115.115 0 0 1 .104.204.114.114 0 1 1-.104-.204Zm-.107-.387a.114.114 0 1 1 .07.216.114.114 0 0 1-.144-.073.113.113 0 0 1 .074-.143Zm-.113-4.904a.114.114 0 0 1 .161-.017.114.114 0 1 1-.144.178.115.115 0 0 1-.017-.161Zm-.321-.237a.114.114 0 0 1 .156-.041.114.114 0 0 1 .042.156.114.114 0 0 1-.156.041.113.113 0 0 1-.042-.156Zm-.289-.036a.115.115 0 0 1-.066-.148.115.115 0 0 1 .214.082.114.114 0 0 1-.148.066Zm-.099 1.321a.116.116 0 0 1 .151-.058.114.114 0 0 1-.092.209.115.115 0 0 1-.059-.151Zm-.178 5.199a.114.114 0 1 1 .114.198.114.114 0 0 1-.114-.198Zm-.128-.381a.116.116 0 0 1 .149.066.114.114 0 0 1-.066.147.114.114 0 1 1-.083-.213Zm-.065-.396a.114.114 0 1 1 .046.224.114.114 0 0 1-.046-.224Zm-.112-.282a.113.113 0 0 1 .108-.12.115.115 0 0 1 .12.108.114.114 0 1 1-.228.012Zm-.052-4.348a.115.115 0 1 1 0-.001v.001Zm-.25 1.24a.113.113 0 0 1 .095-.13.114.114 0 1 1 .036.225.114.114 0 0 1-.131-.095Zm-.086 1.132a.114.114 0 0 1 .162.008.113.113 0 0 1-.008.161.114.114 0 1 1-.154-.169Zm-.061-2.432a.115.115 0 0 1-.229.012.115.115 0 0 1 .229-.012Zm-.1 1.454a.114.114 0 0 1-.144-.074.112.112 0 0 1 .074-.143.115.115 0 0 1 .144.073.114.114 0 0 1-.074.144Zm-.149 1.258a.116.116 0 0 1 .162-.017.114.114 0 1 1-.144.178.114.114 0 0 1-.018-.161Zm-.262.326a.114.114 0 1 1 .198.114.114.114 0 0 1-.198-.114Zm-.142.51a.115.115 0 1 1 .082-.214.115.115 0 0 1-.082.214Zm-.126.378a.115.115 0 0 1-.089-.136.114.114 0 1 1 .089.136Zm-.175.273a.115.115 0 0 1 .12-.108.114.114 0 1 1-.011.228.115.115 0 0 1-.109-.12Zm.014-2.641a.114.114 0 1 1 .134.184.115.115 0 0 1-.16-.025.113.113 0 0 1 .026-.159Zm-.008-1.555a.115.115 0 1 1 .082.214.115.115 0 0 1-.082-.214Zm-.331 1.801a.114.114 0 0 1 .162 0 .113.113 0 0 1 0 .161.114.114 0 1 1-.162-.161Zm-.294.296a.114.114 0 0 1 .159-.025.113.113 0 0 1 .026.159.115.115 0 0 1-.16.025.114.114 0 0 1-.025-.159Z",
  fill: "url(#u)"
})), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
  d: "m245.935 156.653-.293.719a.462.462 0 0 0 .216.586l.246.127c.359.186.746.313 1.146.377l1.111.178 1.601-1.649-.514-1.395a3.86 3.86 0 0 0-.359-.726l-.277-.436a.395.395 0 0 0-.539-.126l-.678.412a.313.313 0 0 0-.142.342l.149.605a.191.191 0 0 1-.045.177l-.514.567a.248.248 0 0 1-.209.08l-.538-.056a.352.352 0 0 0-.361.216v.002Z",
  fill: "url(#v)"
})), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
  d: "M248.602 155.826a1.094 1.094 0 0 0-.644-.272l-1.167 1.317a1.1 1.1 0 0 0 .349.605c.457.403 1.154.36 1.558-.095a1.1 1.1 0 0 0-.096-1.555Zm.067 1.512a1.035 1.035 0 0 1-1.785-.477l-.002-.009.007-.008 1.079-1.216h.009a1.03 1.03 0 0 1 .693 1.71h-.001Z",
  fill: "#000"
})), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
  d: "M248.564 155.86a1.02 1.02 0 0 0-.589-.253l-1.096 1.237c.047.216.158.407.323.553a1.032 1.032 0 0 0 1.452-.089 1.021 1.021 0 0 0-.09-1.449v.001Z",
  fill: "url(#w)"
})), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
  d: "M248.95 156.563a1.061 1.061 0 0 0-.982-.997h-.011l-1.116 1.258-.007.007.002.011a1.06 1.06 0 0 0 1.046.852 1.067 1.067 0 0 0 1.067-1.132l.001.001Zm-.297.745a1.03 1.03 0 0 1-1.774-.464l1.095-1.236c.221.019.426.106.59.252a1.02 1.02 0 0 1 .089 1.449v-.001Z",
  fill: "url(#x)"
})), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
  d: "M248.779 154.715a.338.338 0 1 1-.676 0 .338.338 0 0 1 .676 0Z",
  fill: "url(#y)"
})), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
  d: "M248.264 154.709c0 .099.08.179.179.179a.179.179 0 1 0 0-.358.179.179 0 0 0-.179.179Z",
  fill: "url(#z)"
})), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
  d: "M248.443 154.734a.26.26 0 0 0 .176-.063.18.18 0 1 1-.351 0 .258.258 0 0 0 .175.063Z",
  fill: "url(#A)"
})), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
  d: "M246.439 157.496a.338.338 0 1 1-.677 0 .338.338 0 0 1 .677 0Z",
  fill: "url(#B)"
})), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
  d: "M245.92 157.496c0 .099.08.179.18.179.099 0 .179-.08.179-.179a.18.18 0 1 0-.359 0Z",
  fill: "url(#C)"
})), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
  d: "M246.1 157.521c.07 0 .133-.024.175-.063a.179.179 0 0 1-.175.217.18.18 0 0 1-.176-.217.262.262 0 0 0 .176.063Z",
  fill: "url(#D)"
})), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
  d: "M251.257 162.243a2.926 2.926 0 0 0 2.628-3.198 2.928 2.928 0 0 0-3.205-2.621 2.925 2.925 0 0 0-2.628 3.197 2.93 2.93 0 0 0 3.205 2.622Z",
  fill: "url(#E)"
})), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
  d: "M250.972 159.746c1.148 0 2.175-.398 2.868-1.025a2.927 2.927 0 0 1-2.868 3.527 2.926 2.926 0 0 1-2.868-3.527c.692.627 1.719 1.025 2.868 1.025Z",
  fill: "url(#F)"
})), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
  d: "M246.313 164.286a6.826 6.826 0 0 0 9.633-.319 6.787 6.787 0 0 0-.32-9.61 6.827 6.827 0 0 0-9.633.32 6.787 6.787 0 0 0 .32 9.609Zm-1.203-4.563a.469.469 0 0 1 .576-.484l2.383.557a.415.415 0 0 1 .311.287c.055.181.003.298-.106.41l-1.704 1.754a.47.47 0 0 1-.748-.098 5.853 5.853 0 0 1-.712-2.427v.001Zm7.856-5.915a.468.468 0 0 1 .211.725l-1.475 1.917a.413.413 0 0 1-.391.164c-.188-.025-.273-.121-.331-.265l-.884-2.228a.468.468 0 0 1 .395-.639 5.91 5.91 0 0 1 2.475.327v-.001Zm1.305 10.364a.47.47 0 0 1-.71-.249l-.744-2.371a.414.414 0 0 1 .091-.414c.128-.139.256-.153.407-.117l2.425.581c.305.073.456.42.298.69a5.822 5.822 0 0 1-1.766 1.88h-.001Zm-7.317-.569a5.233 5.233 0 0 1-.297-.299.47.47 0 0 1 .002-.648l1.89-1.947c.205-.211.279-.495.192-.74a.742.742 0 0 0-.558-.504l-2.643-.618a.465.465 0 0 1-.357-.528 5.817 5.817 0 0 1 1.496-3.002 5.837 5.837 0 0 1 2.433-1.554.467.467 0 0 1 .577.275l.981 2.473c.109.273.338.457.598.479a.745.745 0 0 0 .69-.299l1.645-2.138a.467.467 0 0 1 .626-.109 5.861 5.861 0 0 1 2.371 6.557l-.558.316-2.679-.642c-.287-.069-.569.013-.737.212a.74.74 0 0 0-.151.736l.821 2.616-.279.578a5.892 5.892 0 0 1-6.061-1.214h-.002Z",
  fill: "url(#G)"
})), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
  d: "M252.69 166.115a7 7 0 0 0 3.389-1.997 6.99 6.99 0 0 0 1.564-6.93c-1.123-3.503-4.849-5.562-8.422-4.65a7 7 0 0 0-3.389 1.997 6.985 6.985 0 0 0-1.563 6.93c1.123 3.503 4.849 5.561 8.421 4.65Zm-8.285-6.869a.47.47 0 0 1 .6-.445l3.14.902a.5.5 0 0 1 .343.348l.006.021a.477.477 0 0 1-.106.455l-2.159 2.452a.47.47 0 0 1-.746-.053 6.506 6.506 0 0 1-1.077-3.681l-.001.001Zm9.27-5.868a.468.468 0 0 1 .164.729l-2.086 2.451a.5.5 0 0 1-.459.167l-.022-.002a.483.483 0 0 1-.372-.284l-1.327-2.912a.468.468 0 0 1 .355-.656 6.5 6.5 0 0 1 3.748.507h-.001Zm2.062 10.42a6.504 6.504 0 0 1-1.521 1.198.472.472 0 0 1-.69-.288l-.829-3.177a.495.495 0 0 1 .126-.471l.015-.016a.482.482 0 0 1 .447-.141l3.228.607c.304.058.47.388.336.667a6.502 6.502 0 0 1-1.112 1.621Zm-9.32.246a.467.467 0 0 1-.024-.646l2.297-2.607a.878.878 0 0 0 .18-.862.896.896 0 0 0-.614-.61l-3.34-.96a.468.468 0 0 1-.328-.556 6.546 6.546 0 0 1 1.587-2.949 6.516 6.516 0 0 1 2.348-1.595.472.472 0 0 1 .6.243l1.413 3.102a.881.881 0 0 0 .713.517.912.912 0 0 0 .815-.312l2.224-2.612a.469.469 0 0 1 .638-.073 6.484 6.484 0 0 1 2.318 3.359 6.523 6.523 0 0 1 .09 3.321.469.469 0 0 1-.544.35l-3.43-.646a.882.882 0 0 0-.835.284.894.894 0 0 0-.215.837l.882 3.379a.466.466 0 0 1-.314.565l-.076.023a6.524 6.524 0 0 1-4.987-.535 6.555 6.555 0 0 1-1.397-1.02l-.001.003Z",
  fill: "url(#H)"
})), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
  d: "M246.957 163.607a5.894 5.894 0 0 0 6.062 1.214l.081-.17.096.364a.468.468 0 0 1-.314.565l-.077.023a6.524 6.524 0 0 1-4.987-.535 6.59 6.59 0 0 1-1.397-1.02.456.456 0 0 1-.128-.223 9.19 9.19 0 0 0 .623-.26l.041.041v.001Z",
  fill: "url(#I)"
})), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
  d: "M254.99 155.045a5.773 5.773 0 0 0-.39-.333c.064-.224.118-.445.161-.661.06.014.118.04.171.079a6.52 6.52 0 0 1 2.408 6.68.468.468 0 0 1-.545.35l-.351-.066.159-.09a5.859 5.859 0 0 0-1.614-5.96l.001.001Z",
  fill: "url(#J)"
})), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
  d: "m256.518 161.515-3.228-.607a.481.481 0 0 0-.447.14l-.015.017a.496.496 0 0 0-.127.47l.83 3.177a.47.47 0 0 0 .689.288 6.483 6.483 0 0 0 2.634-2.819.47.47 0 0 0-.336-.666Zm-.478.78a5.839 5.839 0 0 1-1.766 1.881.47.47 0 0 1-.709-.25l-.744-2.37a.414.414 0 0 1 .091-.414c.128-.139.256-.153.407-.117l2.425.581c.305.073.456.42.298.689h-.002Z",
  fill: "url(#K)"
})), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
  d: "M252.695 166.119a6.995 6.995 0 0 0 3.39-1.997 6.989 6.989 0 0 0 1.564-6.929 6.971 6.971 0 0 0-2.8-3.681c-.008.066-.018.133-.028.2a9.348 9.348 0 0 1-.06.339c.06.014.119.04.171.079a6.486 6.486 0 0 1 2.317 3.359 6.523 6.523 0 0 1 .091 3.321.468.468 0 0 1-.544.35l-.352-.066-3.079-.58a.884.884 0 0 0-.835.284.895.895 0 0 0-.214.838l.787 3.014.095.364a.468.468 0 0 1-.314.565 6.522 6.522 0 0 1-5.063-.512 6.585 6.585 0 0 1-1.397-1.019.456.456 0 0 1-.129-.224c-.109.04-.217.078-.324.113-.076.024-.151.048-.227.07 1.701 1.873 4.367 2.77 6.953 2.11l-.002.002Zm.837-1.406-.83-3.177a.497.497 0 0 1 .127-.471l.015-.016a.482.482 0 0 1 .447-.141l3.227.607a.47.47 0 0 1 .337.666 6.534 6.534 0 0 1-1.112 1.622 6.509 6.509 0 0 1-1.522 1.198.471.471 0 0 1-.689-.288Z",
  fill: "url(#L)"
})), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
  d: "M250.977 157.97c.751 0 1.36.608 1.36 1.357s-.609 1.356-1.36 1.356c-.751 0-1.36-.607-1.36-1.356 0-.749.609-1.357 1.36-1.357Zm0-.039a1.4 1.4 0 0 0-1.399 1.396 1.399 1.399 0 0 0 2.798 0 1.4 1.4 0 0 0-1.399-1.396Z",
  fill: "#666"
})), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
  d: "M250.901 168.127c-4.934 0-8.948-4.003-8.948-8.925 0-4.922 4.014-8.926 8.948-8.926s8.947 4.004 8.947 8.926c0 4.922-4.013 8.925-8.947 8.925Zm0-17.339c-4.651 0-8.434 3.774-8.434 8.414 0 4.639 3.783 8.413 8.434 8.413 4.65 0 8.434-3.774 8.434-8.413 0-4.64-3.784-8.414-8.434-8.414Z",
  fill: "url(#M)"
})), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
  d: "M198.031 152.553c3.745 0 6.793 3.04 6.793 6.777 0 3.736-3.048 6.776-6.793 6.776-3.746 0-6.793-3.04-6.793-6.776 0-3.737 3.047-6.777 6.793-6.777Zm0-2.495c-5.134 0-9.295 4.151-9.295 9.272 0 5.12 4.161 9.271 9.295 9.271 5.133 0 9.294-4.151 9.294-9.271 0-5.121-4.161-9.272-9.294-9.272Z",
  fill: "url(#N)"
})), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
  d: "M198.098 168.287c-4.934 0-8.948-4.004-8.948-8.926 0-4.922 4.014-8.926 8.948-8.926s8.947 4.004 8.947 8.926c0 4.922-4.013 8.926-8.947 8.926Zm0-17.34c-4.651 0-8.434 3.774-8.434 8.414 0 4.639 3.783 8.413 8.434 8.413s8.434-3.774 8.434-8.413c0-4.64-3.783-8.414-8.434-8.414Z",
  fill: "url(#O)"
})), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
  d: "M193.787 159.313a4.24 4.24 0 0 0 4.245 4.234 4.24 4.24 0 0 0 4.245-4.234 4.24 4.24 0 0 0-4.245-4.234 4.239 4.239 0 0 0-4.245 4.234Zm1.505-2.054a.114.114 0 1 1-.048-.224.114.114 0 0 1 .048.224Zm-.078 1.228a.114.114 0 1 1 .104.204.114.114 0 0 1-.104-.204Zm1.186 2.523a.115.115 0 0 1 .102.125.115.115 0 1 1-.228-.024.114.114 0 0 1 .126-.101Zm-.057-3.768a.115.115 0 0 1 .221.058.115.115 0 0 1-.222-.058h.001Zm.249-1.402a.115.115 0 0 1-.224-.047.114.114 0 0 1 .136-.088.113.113 0 0 1 .088.135Zm.011 4.927a.116.116 0 0 1-.141.081.114.114 0 1 1 .06-.22.114.114 0 0 1 .081.14v-.001Zm1.255-3.974a.114.114 0 1 1-.153-.17.116.116 0 0 1 .162.008.115.115 0 0 1-.009.162Zm1.043-.874a.113.113 0 0 1-.159-.026.114.114 0 0 1 .025-.159.114.114 0 1 1 .134.185Zm.274.752a.114.114 0 1 1-.07-.217.114.114 0 0 1 .07.217Zm.045.399a.115.115 0 0 1-.131-.095.116.116 0 0 1 .096-.131.116.116 0 0 1 .131.095.115.115 0 0 1-.096.131Zm1.008.649a.115.115 0 1 1-.082.214.115.115 0 0 1 .082-.214Zm.195-1.344a.116.116 0 0 1-.141-.081.115.115 0 1 1 .14.081h.001Zm.024.401a.115.115 0 1 1-.024-.228.115.115 0 0 1 .024.228Zm1.207 3.274a.114.114 0 1 1 .144.178.114.114 0 0 1-.144-.178Zm-.055-1.937a.113.113 0 0 1-.073-.143.114.114 0 1 1 .217.07.114.114 0 0 1-.144.073Zm-.199.35a.114.114 0 1 1 .104-.204.114.114 0 0 1-.104.204Zm-.079 1.776a.114.114 0 1 1 .115.198.114.114 0 0 1-.115-.198Zm-.197-1.622a.114.114 0 1 1 .185.134.115.115 0 0 1-.16.025.114.114 0 0 1-.025-.159Zm-.161 1.758a.116.116 0 0 1 .149.065.115.115 0 0 1-.066.148.114.114 0 0 1-.148-.066.113.113 0 0 1 .065-.147Zm-.111-1.489a.116.116 0 0 1 .162 0 .114.114 0 0 1 0 .162.116.116 0 0 1-.162 0 .116.116 0 0 1 0-.162Zm-.227 2.978a.115.115 0 1 1 .024.228.115.115 0 0 1-.024-.228Zm-.036-1.411a.114.114 0 1 1 .047.223.114.114 0 1 1-.047-.223Zm-.047-1.344a.115.115 0 1 1 .135.185.115.115 0 0 1-.135-.185Zm-.134-1.934a.113.113 0 0 1-.108-.119.115.115 0 0 1 .12-.109.115.115 0 0 1 .108.12.113.113 0 0 1-.12.108Zm-.101.389a.114.114 0 1 1 .048-.224.114.114 0 0 1-.048.224Zm-.002 1.921a.116.116 0 0 1-.154-.05.115.115 0 0 1 .204-.104.115.115 0 0 1-.05.154Zm-.182 2.465a.115.115 0 0 1 .229.012.115.115 0 0 1-.229-.012Zm-.024-1.359a.114.114 0 1 1 .12.108.114.114 0 0 1-.12-.108Zm-.169-2.321a.114.114 0 1 1 .115-.198.114.114 0 0 1-.115.198Zm-.196 3.579a.114.114 0 0 1 .224.047.114.114 0 0 1-.224-.047Zm-.033-1.318a.115.115 0 0 1 .125-.102.115.115 0 0 1 .103.126.115.115 0 0 1-.229-.024h.001Zm-.336 1.157a.115.115 0 1 1 .214.082.115.115 0 0 1-.214-.082Zm-.163-4.218a.114.114 0 1 1 0-.228c.063 0 .115.051.115.114a.115.115 0 0 1-.115.114Zm-.177 4.002a.114.114 0 1 1 .2.114.114.114 0 0 1-.2-.114Zm-.111-5.239a.114.114 0 1 1 .204-.104.114.114 0 0 1-.204.104Zm-.173 5.134a.114.114 0 1 1 .144-.178.114.114 0 0 1-.144.178Zm-.122 1.509a.114.114 0 1 1 .204.104.114.114 0 0 1-.204-.104Zm-.102-7.294a.114.114 0 1 1 .162-.161.113.113 0 0 1 0 .161.114.114 0 0 1-.162 0Zm-.213 7.043a.115.115 0 0 1 .16-.025.114.114 0 0 1 .025.159.114.114 0 1 1-.185-.134Zm-.271-.296a.114.114 0 1 1 .161.162.114.114 0 0 1-.161-.162Zm-.129-5.225a.113.113 0 0 1 .033-.158.116.116 0 0 1 .159.034.114.114 0 0 1-.192.124Zm-.093 4.89a.114.114 0 1 1 .134.185.113.113 0 0 1-.159-.026.114.114 0 0 1 .025-.159Zm-.167-.365a.114.114 0 1 1 .105.203.115.115 0 0 1-.155-.049.115.115 0 0 1 .05-.154Zm-.107-.388a.114.114 0 0 1 .071.217.114.114 0 0 1-.144-.073.116.116 0 0 1 .073-.144Zm-.112-4.903a.114.114 0 1 1 .178.144.114.114 0 0 1-.178-.144Zm-.322-.237a.115.115 0 0 1 .157-.041.114.114 0 0 1 .042.156.115.115 0 0 1-.157.041.114.114 0 0 1-.042-.156Zm-.288-.036a.115.115 0 0 1-.066-.148.114.114 0 0 1 .148-.065.114.114 0 1 1-.082.213Zm-.099 1.321a.116.116 0 0 1 .151-.058.114.114 0 1 1-.093.208.115.115 0 0 1-.058-.15Zm-.178 5.199a.114.114 0 0 1 .156.042.114.114 0 1 1-.156-.042Zm-.128-.381a.114.114 0 1 1 .082.213.115.115 0 0 1-.148-.065.115.115 0 0 1 .066-.148Zm-.066-.396a.114.114 0 1 1 .048.224.114.114 0 0 1-.048-.224Zm-.112-.282a.115.115 0 0 1 .229-.012.114.114 0 0 1-.109.12.114.114 0 0 1-.12-.108Zm-.051-4.348a.115.115 0 0 1-.126.102.115.115 0 0 1-.102-.125.115.115 0 0 1 .126-.102.115.115 0 0 1 .102.126v-.001Zm-.25 1.24a.114.114 0 1 1 .131.095.113.113 0 0 1-.131-.095Zm-.086 1.132a.114.114 0 1 1-.008.161.113.113 0 0 1 .008-.161Zm-.062-2.432a.113.113 0 0 1-.108.12.115.115 0 0 1-.12-.109.113.113 0 0 1 .108-.119.113.113 0 0 1 .12.108Zm-.099 1.453a.114.114 0 1 1-.071-.216.113.113 0 0 1 .144.073.112.112 0 0 1-.073.143Zm-.149 1.259a.114.114 0 1 1 .178.144.114.114 0 0 1-.178-.144Zm-.263.326a.114.114 0 1 1 .2.114.114.114 0 0 1-.2-.114Zm-.142.509a.114.114 0 0 1 .083-.213.115.115 0 0 1 .066.148.115.115 0 0 1-.149.065Zm-.126.379a.115.115 0 0 1-.088-.136.115.115 0 1 1 .088.136Zm-.174.273a.114.114 0 1 1 .228.012.114.114 0 0 1-.228-.012Zm.013-2.642a.115.115 0 0 1 .16.026.114.114 0 0 1-.025.159.115.115 0 0 1-.135-.185Zm-.007-1.554a.115.115 0 0 1 .148.066.115.115 0 0 1-.066.148.115.115 0 1 1-.082-.214Zm-.331 1.801a.114.114 0 1 1 .162.16.114.114 0 0 1-.162-.16Zm-.295.296a.115.115 0 0 1 .16-.025.114.114 0 1 1-.134.184.113.113 0 0 1-.026-.159Z",
  fill: "url(#P)"
})), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
  d: "m200.749 154.266-.721-.292a.463.463 0 0 0-.587.216l-.127.245a3.806 3.806 0 0 0-.378 1.143l-.178 1.109 1.653 1.596 1.398-.513a3.84 3.84 0 0 0 .728-.357l.437-.277a.395.395 0 0 0 .127-.538l-.413-.676a.315.315 0 0 0-.343-.141l-.607.148a.196.196 0 0 1-.178-.044l-.567-.512a.247.247 0 0 1-.081-.209l.056-.537a.35.35 0 0 0-.217-.36l-.002-.001Z",
  fill: "url(#Q)"
})), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
  d: "M201.607 156.955a1.09 1.09 0 0 0 .272-.642l-1.32-1.165a1.1 1.1 0 0 0-.511 1.903c.457.403 1.154.36 1.558-.095l.001-.001Zm-1.516.067a1.03 1.03 0 0 1 .477-1.781l.01-.002.008.007 1.219 1.076v.01a1.029 1.029 0 0 1-.966.947 1.029 1.029 0 0 1-.748-.256v-.001Z",
  fill: "#000"
})), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
  d: "M201.544 156.89c.147-.165.234-.368.253-.588l-1.239-1.094a1.025 1.025 0 0 0 .279 2.027c.275-.017.526-.139.708-.345h-.001Z",
  fill: "url(#R)"
})), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
  d: "M200.841 157.277c.285-.017.546-.144.735-.358.155-.173.246-.389.264-.622v-.01l-1.261-1.114-.007-.007-.011.002a1.064 1.064 0 0 0-.493 1.843c.214.189.489.283.774.265l-.001.001Zm-.747-.296a1.025 1.025 0 0 1 .465-1.771l1.24 1.094a1.027 1.027 0 0 1-1.706.677h.001Z",
  fill: "url(#S)"
})), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
  d: "M202.69 157.103a.338.338 0 1 0 .001-.675.338.338 0 0 0-.001.675Z",
  fill: "url(#T)"
})), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
  d: "M202.518 156.768c0 .099.08.179.179.179a.18.18 0 1 0-.179-.179Z",
  fill: "url(#U)"
})), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
  d: "M202.697 156.793a.265.265 0 0 0 .176-.063.179.179 0 0 1-.176.216.179.179 0 0 1-.175-.216.263.263 0 0 0 .175.063Z",
  fill: "url(#V)"
})), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
  d: "M199.905 154.769a.338.338 0 1 1-.001-.675.338.338 0 0 1 .001.675Z",
  fill: "url(#W)"
})), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
  d: "M199.725 154.431c0 .099.08.179.179.179a.18.18 0 1 0-.179-.179Z",
  fill: "url(#X)"
})), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
  d: "M199.904 154.456a.263.263 0 0 0 .176-.063.179.179 0 0 1-.176.216.179.179 0 0 1-.175-.216.263.263 0 0 0 .175.063Z",
  fill: "url(#Y)"
})), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
  d: "M200.885 160.012a2.923 2.923 0 0 0-2.164-3.526 2.924 2.924 0 1 0-1.371 5.685 2.932 2.932 0 0 0 3.535-2.159Z",
  fill: "url(#Z)"
})), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
  d: "M198.034 159.75c-1.148 0-2.175-.397-2.867-1.024a2.927 2.927 0 0 0 2.867 3.527 2.927 2.927 0 0 0 2.868-3.527c-.692.626-1.719 1.024-2.867 1.024h-.001Z",
  fill: "url(#aa)"
})), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
  d: "M197.838 152.54c-3.762.109-6.723 3.24-6.614 6.993.109 3.754 3.247 6.708 7.01 6.599 3.763-.109 6.724-3.24 6.615-6.993-.109-3.754-3.248-6.708-7.011-6.599Zm5.73 4.817a.468.468 0 0 1-.421.624l-2.446.114c-.156.007-.279-.031-.378-.192a.411.411 0 0 1-.011-.423l1.158-2.15a.469.469 0 0 1 .745-.11 5.855 5.855 0 0 1 1.353 2.137Zm-9.604-2.243a.47.47 0 0 1 .742.127l1.089 2.136c.071.139.087.266-.019.422a.413.413 0 0 1-.382.184l-2.417-.165a.47.47 0 0 1-.406-.638 5.904 5.904 0 0 1 1.393-2.067v.001Zm4.243 10.083a5.8 5.8 0 0 1-1.291-.106.468.468 0 0 1-.322-.678l1.168-2.198c.074-.138.168-.224.357-.227a.413.413 0 0 1 .371.206l1.29 2.126a.468.468 0 0 1-.282.695c-.414.107-.845.17-1.29.182h-.001Zm2.605-.694-.618-.173-1.423-2.346a.745.745 0 0 0-.654-.373c-.26-.006-.508.151-.646.41l-1.291 2.429-.607.208a5.866 5.866 0 0 1-3.359-6.113.467.467 0 0 1 .496-.396l2.695.185a.747.747 0 0 0 .683-.318c.155-.209.168-.502.035-.764l-1.21-2.371a.464.464 0 0 1 .175-.613 5.853 5.853 0 0 1 2.778-.791 5.848 5.848 0 0 1 3.246.868c.209.128.277.4.161.616l-1.285 2.387a.739.739 0 0 0 .01.751c.127.227.388.36.683.346l2.713-.126a.472.472 0 0 1 .49.428 5.868 5.868 0 0 1-3.072 5.757v-.001Z",
  fill: "url(#ab)"
})), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
  d: "M204.081 155.744a7.02 7.02 0 0 0-6.243-3.417 7.012 7.012 0 0 0-3.744 1.214c-3.049 2.069-3.967 6.217-2.078 9.376a7.024 7.024 0 0 0 6.243 3.416 7.022 7.022 0 0 0 3.743-1.213c3.049-2.069 3.968-6.217 2.079-9.376Zm-.487.101c.352.558.614 1.155.783 1.774a.468.468 0 0 1-.454.592l-3.272-.007a.484.484 0 0 1-.413-.222l-.011-.019a.5.5 0 0 1-.035-.487l1.4-2.945a.471.471 0 0 1 .731-.154c.489.419.92.911 1.271 1.467v.001Zm-9.716-1.556a.47.47 0 0 1 .728.169l1.31 2.919a.48.48 0 0 1-.045.485.495.495 0 0 1-.429.232l-3.222-.061a.47.47 0 0 1-.44-.606 6.478 6.478 0 0 1 2.099-3.139l-.001.001Zm2.413 11.335a.47.47 0 0 1-.278-.692l1.679-2.816a.486.486 0 0 1 .402-.241h.022a.5.5 0 0 1 .438.217l1.838 2.722a.469.469 0 0 1-.239.706 6.478 6.478 0 0 1-3.862.104Zm8.148-4.847a6.488 6.488 0 0 1-2.966 4.126.47.47 0 0 1-.632-.14l-1.955-2.896a.9.9 0 0 0-.771-.393.883.883 0 0 0-.766.437l-1.785 2.992a.47.47 0 0 1-.624.176 6.56 6.56 0 0 1-2.435-2.265 6.47 6.47 0 0 1-.991-3.957.467.467 0 0 1 .477-.429l3.434.066a.91.91 0 0 0 .774-.403.881.881 0 0 0 .083-.877l-1.396-3.11a.468.468 0 0 1 .214-.609 6.53 6.53 0 0 1 2.753-.701 6.571 6.571 0 0 1 3.265.765.466.466 0 0 1 .201.613l-1.489 3.134a.894.894 0 0 0 .054.862.882.882 0 0 0 .767.436l3.479.007c.25 0 .459.197.468.446a6.51 6.51 0 0 1-.158 1.719l-.001.001Z",
  fill: "url(#ac)"
})), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
  d: "M203.91 159.172a5.868 5.868 0 0 1-3.099 5.337l-.182-.051.21.312c.14.207.419.269.633.14.022-.014.045-.029.068-.042a6.501 6.501 0 0 0 2.898-4.084c.13-.572.181-1.149.158-1.719a.458.458 0 0 0-.083-.244 8.806 8.806 0 0 1-.608.295c.001.019.004.038.004.058l.001-.002Z",
  fill: "url(#ad)"
})), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
  d: "M192.16 159.512a5.81 5.81 0 0 1 .009-.512 8.75 8.75 0 0 1-.604-.317.454.454 0 0 0-.053.18 6.48 6.48 0 0 0 .991 3.956 6.54 6.54 0 0 0 2.436 2.265c.22.119.496.04.623-.175l.183-.306-.174.059a5.868 5.868 0 0 1-3.411-5.151v.001Z",
  fill: "url(#ae)"
})), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
  d: "M196.292 165.631a6.516 6.516 0 0 0 3.861-.104.47.47 0 0 0 .24-.706l-1.839-2.723a.498.498 0 0 0-.437-.217h-.022a.485.485 0 0 0-.402.242l-1.679 2.815a.47.47 0 0 0 .278.693Zm.302-1.212 1.168-2.198c.074-.137.168-.224.357-.227a.412.412 0 0 1 .371.207l1.29 2.125a.469.469 0 0 1-.282.696 5.885 5.885 0 0 1-2.581.076.468.468 0 0 1-.322-.679h-.001Z",
  fill: "url(#af)"
})), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
  d: "m205.016 158.529-.202.123a9.41 9.41 0 0 1-.3.168c.049.07.08.153.083.243a6.56 6.56 0 0 1-.158 1.72 6.496 6.496 0 0 1-2.898 4.083l-.068.042a.469.469 0 0 1-.632-.139l-.211-.312-1.744-2.584a.9.9 0 0 0-.772-.393.88.88 0 0 0-.766.436l-1.602 2.686-.182.307a.47.47 0 0 1-.624.175 6.544 6.544 0 0 1-2.435-2.265 6.469 6.469 0 0 1-.991-3.957.454.454 0 0 1 .053-.18 7.694 7.694 0 0 1-.295-.179c-.056-.036-.114-.073-.168-.11a6.943 6.943 0 0 0 .913 4.529 7.022 7.022 0 0 0 6.242 3.417 7.015 7.015 0 0 0 3.744-1.214c2.207-1.497 3.297-4.084 3.014-6.596h-.001Zm-4.865 6.998a6.497 6.497 0 0 1-3.861.104.47.47 0 0 1-.278-.693l1.679-2.815a.485.485 0 0 1 .402-.242h.022a.498.498 0 0 1 .437.217l1.839 2.723a.47.47 0 0 1-.24.706Z",
  fill: "url(#ag)"
})), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
  d: "M198.032 157.974c.751 0 1.36.607 1.36 1.356 0 .749-.609 1.357-1.36 1.357-.751 0-1.36-.608-1.36-1.357s.609-1.356 1.36-1.356Zm0-.039c-.772 0-1.399.625-1.399 1.395a1.399 1.399 0 0 0 2.798 0c0-.77-.628-1.395-1.399-1.395Z",
  fill: "#666"
})), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
  d: "m243.292 156.217.659-.22a27.52 27.52 0 0 0 8.823-4.906l.673-.557a.293.293 0 0 0-.122-.51l-.634-.144c-4.242-.968-8.521 1.467-9.844 5.602l-.073.226a.406.406 0 0 0 .517.508l.001.001Z",
  fill: "url(#ah)"
})), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
  d: "M250.028 149.707a8.37 8.37 0 0 0-7.195 5.776l-.073.226a.407.407 0 0 0 .517.508l.606-.203c.961-3.174 3.327-5.47 6.145-6.307Z",
  fill: "url(#ai)"
})), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
  d: "m246.883 146.189.135.128a.15.15 0 0 1 .046.108 6.954 6.954 0 0 1-.5 2.519l-2.632 6.537c-.879 2.181-2.594 4.24-4.673 5.383-2.731 1.502-6.334 1.53-9.372 1.465-3.545-.075-7.088-.571-10.576-1.183-3.296-.578-6.583-1.267-9.67-2.593l-.02-.008a14.661 14.661 0 0 1-3.834-2.406l-7.583-6.586a35.993 35.993 0 0 1-4.036-4.117 2.619 2.619 0 0 1-.595-1.89l.01-.123a4.83 4.83 0 0 1 2.001-3.541l1.083-.777a4.955 4.955 0 0 1 1.235-.643l1.446-.507 10.721 4.56 3.621 9.902 9.926 5.068 11.841.507 6.409-6.16 2.071-7.212 1.641-.117.864 1.186c.131.179.278.347.44.5h.001Z",
  fill: "url(#aj)"
})), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
  d: "m232.849 157.89-4.065-.174c-2.972.141-5.964.023-8.926-.181-1.297-.089-3.694-.646-6.142-1.295a43.042 43.042 0 0 1-13.645-6.33l-2.423-1.694a35.977 35.977 0 0 1-3.431-2.722 36.062 36.062 0 0 0 3.998 4.069l7.585 6.588a14.68 14.68 0 0 0 3.832 2.404l.019.008c3.088 1.326 6.376 2.014 9.671 2.592 2.438.429 7.234.579 11.276.326 2.677-.168 5.268-1 7.553-2.401l1.646-1.01-6.946-.18h-.002Z",
  fill: "url(#ak)"
})), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
  d: "M237.918 144.972c-.034-.31-2.572-9.512-3.161-11.646a.518.518 0 0 1 .3-.616l2.354-.992.508 13.254h-.001Z",
  fill: "url(#al)"
})), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
  d: "m237.921 130.284 3.321 4.142a42.057 42.057 0 0 1 5.353 8.642c.283.613.436 1.277.45 1.951l.015.742c.002.054-.064.083-.103.046l-.277-.262a3.447 3.447 0 0 0-2.616-.933l-.127.008-3.322-7.757-2.695-6.579h.001Z",
  fill: "url(#am)"
})), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
  d: "M246.604 143.098c-.058-.127-.122-.251-.181-.376-1.005-.609-2.328-.93-3.685-.892l1.208 2.821.127-.009a3.452 3.452 0 0 1 2.616.933l.306.289c.028.028.076.006.074-.033l-.015-.782a4.898 4.898 0 0 0-.451-1.951h.001Z",
  fill: "url(#an)"
})), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
  d: "M246.997 145.866c.028.027.075.007.075-.031.007-.353.009-1.563-.258-2.242-.065-.164-.121-.333-.196-.495-.062-.133-.128-.263-.19-.395l-.062-.019-.352.203.166.938.238 1.518.177.147.403.377-.001-.001Z",
  fill: "url(#ao)"
})), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
  d: "m246.179 143.823-.166-.938-.075-.427a6.015 6.015 0 0 0-.753-.297l-.455.381.327.894.256.702.136.373.099.27-.218-.038-.485-.085.065.023c.193.033.382.081.566.145.208.074.397.164.588.276l.135.083.253.185-.272-1.546-.001-.001Z",
  fill: "url(#ap)"
})), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
  d: "m245.448 144.511-.136-.373-.256-.701-.326-.895-.201-.549a7.204 7.204 0 0 0-.665-.111l-.458.544.478.825.374.646.199.344.144.249.079.158.625.134.269.088-.125-.358-.001-.001Z",
  fill: "url(#aq)"
})), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
  d: "m244.457 144.241-.199-.344-.375-.646-.477-.825-.344-.595c-.104-.001-.207-.004-.31-.001l.389.91.357.832.302.707.075.384.457-.013h.36l-.236-.409h.001Z",
  fill: "url(#ar)"
})), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
  d: "M243.161 142.094c1.129.039 2.199.326 3.049.82l.037.076.105.219a4.68 4.68 0 0 1 .433 1.875l.003.155a3.845 3.845 0 0 0-2.49-.909h-.002a.266.266 0 0 1-.246-.16l-.889-2.076m-.265-.325c-.073 0-.145 0-.217.002-.002 0-.004.003-.003.005l1.238 2.89s.001.002.002.001l.129-.009a3.54 3.54 0 0 1 2.686.959l.314.297a.046.046 0 0 0 .077-.035l-.017-.802a5.004 5.004 0 0 0-.463-2.004 13.168 13.168 0 0 0-.153-.317.243.243 0 0 0-.098-.108c-.967-.568-2.211-.88-3.496-.88l.001.001Z",
  fill: "url(#as)"
})), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
  d: "m221.733 147.863-.602 3.805c-.393 2.48 1.507 4.732 4.024 4.769l8.349.123c3.293.048 4.911-3.129 4.676-6.69-.472-3.69-.994-7.338-1.181-11.055-.085-1.666-.264-3.359-.239-5.026.01-.692.086-1.404.314-2.062l.49-1.417a.196.196 0 0 1 .358-.027l1.963 3.724a46.003 46.003 0 0 1 3.323 8.08l.594 1.956c.385 1.265.631 2.567.736 3.885l.078.97a9.84 9.84 0 0 1-2.924 7.779c-2.385 2.329-5.811 2.821-9.01 2.841a82.832 82.832 0 0 1-11.522-.748 73.524 73.524 0 0 1-4.754-.798c-2.219-.448-4.333-1.161-5.948-2.824-1.984-2.043-2.553-4.943-1.792-7.648l1.403-4.984 11.515 4.314c.153.322.204.682.149 1.034v-.001Z",
  fill: "url(#at)"
})), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
  d: "M237.954 148.133c-.129-2.946-.238-5.878-.103-8.828.076-1.668.047-3.372.247-5.028.083-.687.244-1.386.571-2.013l.146-.282-.895-1.698a.195.195 0 0 0-.357.027l-.491 1.417c-.227.658-.304 1.369-.314 2.062-.025 1.667.154 3.359.239 5.026.158 3.133.554 6.217.956 9.318l.001-.001Z",
  fill: "url(#au)"
})), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
  d: "m206.787 142.685 13.261 4.72a3.85 3.85 0 0 0 1.713.198l-.006-.327a1.137 1.137 0 0 0-.777-1.059l-12.856-4.305-1.335.773Z",
  fill: "url(#av)"
})), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
  d: "m207.89 142.131-1.078.567 2.941 1.046.244-.837-2.107-.776Z",
  fill: "url(#aw)"
})), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
  d: "M208.883 142.282a1.565 1.565 0 0 1-1.801.524l-10.014-3.965 1.879-1.237 10.21 4.482-.274.195v.001Z",
  fill: "url(#ax)"
})), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
  d: "m236.695 124.064-.665-1.202a.237.237 0 0 0-.39-.036l-3.165 3.863 4.22-2.625Z",
  fill: "url(#ay)"
})), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
  d: "m235.064 132.291 1.742-.627a.649.649 0 0 0 .428-.656l-.051-.726a4.76 4.76 0 0 1 .953-3.205c.343-.452.858-.697.891-1.324.065-1.223-1.52-1.919-2.566-1.64a7.723 7.723 0 0 0-3.71 2.256c-.108.118-.344.312-.352.482-.01.195.164.492.234.684l.247.676.619 1.692.733 2.001a.652.652 0 0 0 .832.387Z",
  fill: "url(#az)"
})), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
  d: "M236.463 124.11a7.726 7.726 0 0 0-3.25 1.792c.135.003.271.005.409.005 2.199 0 4.121-.393 5.171-.98-.472-.69-1.551-1.024-2.331-.816l.001-.001Z",
  fill: "url(#aA)"
})), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
  d: "M197.853 136.699c1.912-1.166 4.125-.929 6.269-.89 4.094.073 8.201.247 12.288.47 4.107.225 7.037 4.064 6.161 8.073l-.423 1.937a.717.717 0 0 1-.936.523l-12.315-4.282a64.237 64.237 0 0 1-11.042-5.054.45.45 0 0 1 0-.777h-.002Z",
  fill: "url(#aB)"
})), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
  d: "M197.854 137.475c.125.072.55.321.675.392 1.792-.498 3.438-.53 5.337-.5 4.621.074 9.257.247 13.872.471a8.212 8.212 0 0 1 3.571.994 6.652 6.652 0 0 0-4.898-2.554 335.74 335.74 0 0 0-12.287-.47c-2.145-.039-4.358-.276-6.27.89a.452.452 0 0 0 0 .777Z",
  fill: "url(#aC)"
})), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
  d: "m209.98 142.901-1.515-.522 2.047-6.452a.15.15 0 0 1 .149-.102l1.346.054c.102.004.173.102.144.195l-2.171 6.827Z",
  fill: "url(#aD)"
})), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
  d: "M234.723 120.805a.234.234 0 0 0 .208.175c.024.003.049.004.073.006.152.012.262.15.242.301a33.737 33.737 0 0 0-.324 4.712c0 .092.074.165.165.164l.129-.001a.166.166 0 0 0 .164-.165 33.305 33.305 0 0 1 .347-4.84c.014-.1.077-.246.175-.276.037-.011.074-.024.109-.037-.433-.036-.856-.004-1.288-.039Z",
  fill: "url(#aE)"
})), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
  d: "M235.336 118.242h-.559a.064.064 0 0 0-.064.064v2.652c0 .036.029.065.065.065h.599c.84 0 1.512-.75 1.377-1.61-.107-.684-.726-1.171-1.419-1.171h.001Z",
  fill: "url(#aF)"
})), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
  d: "M236.585 118.944a1.398 1.398 0 0 1-1.306.909h-.566v1.098c0 .039.032.071.072.071l.551.004c.706 0 1.295-.411 1.422-1.205a1.328 1.328 0 0 0-.173-.878v.001Z",
  fill: "url(#aG)"
})), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
  d: "M236.03 127.075c0 .64-.608 1.208-1.25 1.208s-1.075-.567-1.075-1.208.235-1.17 1.162-1.16a1.166 1.166 0 0 1 1.163 1.16Z",
  fill: "url(#aH)"
})), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
  d: "M234.65 128.301c.64 0 1.159-.532 1.159-1.19 0-.657-.519-1.19-1.159-1.19-.641 0-1.16.533-1.16 1.19 0 .658.519 1.19 1.16 1.19Z",
  fill: "url(#aI)"
})), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.109h1.964v-.009l-.002-.023h-1.962v.032Z",
  fill: "url(#aJ)"
})), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.727h1.858l-.019-.032h-1.839v.032Z",
  fill: "url(#aK)"
})), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.205h1.955l.005-.032h-1.96v.032Z",
  fill: "url(#aL)"
})), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.822h1.908l-.015-.031h-1.893v.031Z",
  fill: "url(#aM)"
})), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.918h1.939l-.008-.032h-1.931v.032Z",
  fill: "url(#aN)"
})), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.3h1.935l.008-.031h-1.943v.031Z",
  fill: "url(#aO)"
})), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.682h1.669a.609.609 0 0 0 .04-.031h-1.709v.031Z",
  fill: "url(#aP)"
})), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.778h1.499l.07-.031h-1.569v.031Z",
  fill: "url(#aQ)"
})), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.396h1.9a.43.43 0 0 0 .013-.032h-1.913v.032Z",
  fill: "url(#aR)"
})), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.587h1.774l.028-.031h-1.802v.031Z",
  fill: "url(#aS)"
})), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.491h1.848l.019-.031h-1.867v.031Z",
  fill: "url(#aT)"
})), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.013h1.957l-.004-.031h-1.953v.031Z",
  fill: "url(#aU)"
})), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.631h1.79l-.029-.031h-1.761v.031Z",
  fill: "url(#aV)"
})), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.536h1.693a.685.685 0 0 0-.043-.032h-1.65v.032Z",
  fill: "url(#aW)"
})), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.408v.031h1.538a1.078 1.078 0 0 0-.079-.031h-1.459Z",
  fill: "url(#aX)"
})), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.829h1.233a.735.735 0 0 0 .266-.05h-1.499v.05Z",
  fill: "url(#aY)"
})), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.747h1.569a.851.851 0 0 0 .1-.064h-1.669v.064Z",
  fill: "url(#aZ)"
})), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.651h1.709a.562.562 0 0 0 .065-.064h-1.774v.064Z",
  fill: "url(#ba)"
})), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.555h1.802l.046-.064h-1.848v.064Z",
  fill: "url(#bb)"
})), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.46h1.867a.642.642 0 0 0 .033-.064h-1.9v.064Z",
  fill: "url(#bc)"
})), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.364h1.913c.008-.021.016-.042.022-.063h-1.935v.063Z",
  fill: "url(#bd)"
})), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.268h1.943a.698.698 0 0 0 .012-.063h-1.955v.063Z",
  fill: "url(#be)"
})), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.173h1.96l.003-.064h-1.963v.064Z",
  fill: "url(#bf)"
})), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 127.078h1.962a.46.46 0 0 0-.005-.064h-1.957v.064Z",
  fill: "url(#bg)"
})), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.982h1.953a1.019 1.019 0 0 0-.014-.064h-1.939v.064Z",
  fill: "url(#bh)"
})), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.886h1.931a.7.7 0 0 0-.024-.064h-1.907v.064Z",
  fill: "url(#bi)"
})), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.79h1.893a.63.63 0 0 0-.034-.063h-1.859v.063Z",
  fill: "url(#bj)"
})), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.695h1.839a.635.635 0 0 0-.049-.064h-1.79v.064Z",
  fill: "url(#bk)"
})), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.599h1.761c-.022-.022-.044-.044-.068-.063h-1.693v.063Z",
  fill: "url(#bl)"
})), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
  d: "M233.264 126.504h1.65a.65.65 0 0 0-.112-.064h-1.538v.064Z",
  fill: "url(#bm)"
})), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
  d: "M234.499 126.372h-1.233v.036h1.459a.737.737 0 0 0-.226-.036Z",
  fill: "url(#bn)"
})), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
  d: "M233.993 127.167a.728.728 0 1 0-1.451-.124.728.728 0 0 0 1.451.124Z",
  fill: "url(#bo)"
})), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
  d: "m235.964 127.338-1.081-.13v-.312l1.081-.129a.257.257 0 0 1 .287.254v.063a.257.257 0 0 1-.287.254Z",
  fill: "url(#bp)"
})), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
  d: "M235.404 127.066a.293.293 0 1 1-.585-.001.293.293 0 0 1 .585.001Z",
  fill: "url(#bq)"
})), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
  d: "M235.37 126.929a.296.296 0 0 1-.265.166.29.29 0 0 1-.259-.157.293.293 0 1 0 .522-.009h.002Z",
  fill: "url(#br)"
})), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
  d: "M233.175 127.764a.655.655 0 1 0-.01-1.31.655.655 0 0 0 .01 1.31Z",
  fill: "url(#bs)"
})), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
  d: "M215.54 158.434h-.365a.692.692 0 0 1-.691-.689c0-.378.311-.688.691-.688h.365c.38 0 .69.31.69.688 0 .379-.31.689-.69.689Z",
  fill: "#000"
})), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
  d: "M215.903 157.875a.57.57 0 0 0-1.108-.262.569.569 0 0 0 1.108.262Z",
  fill: "url(#bt)"
})), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
  d: "M215.771 157.733a.426.426 0 1 1-.853-.003.426.426 0 0 1 .853.003Z",
  fill: "url(#bu)"
})), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
  d: "M215.346 157.884a.532.532 0 0 1-.425-.201.426.426 0 0 0 .425.476.425.425 0 0 0 .422-.476.526.526 0 0 1-.422.201Z",
  fill: "url(#bv)"
})), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
  d: "m199.891 142.363-5.098-2.102a.22.22 0 0 1-.12-.288l.482-1.165a.235.235 0 0 1 .307-.127l5.086 2.097c.439.18.647.682.466 1.12a.86.86 0 0 1-1.123.465Z",
  fill: "url(#bw)"
})), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
  d: "M200.793 141.599a.526.526 0 1 1-1.057 0 .526.526 0 0 1 1.057 0Z",
  fill: "url(#bx)"
})), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
  d: "M200.693 141.599a.426.426 0 1 1-.853-.003.426.426 0 0 1 .853.003Z",
  fill: "url(#by)"
})), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
  d: "M200.266 141.75a.532.532 0 0 1-.425-.201.426.426 0 0 0 .425.476.425.425 0 0 0 .422-.475.526.526 0 0 1-.422.201v-.001Z",
  fill: "url(#bz)"
})), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
  d: "M196.328 138.696c.356.062.555.473.387 1.012-.232.748-.657.858-1.125.799-.469-.059-1.729-.283-1.891-.075-.059.075-.369.919-.887 1.581-.189.241-1.03 1.126-1.156 1.196-.127.07-.428.093-.555 0-.127-.093 0-1.382.844-2.717.843-1.335.958-1.376.993-1.547.035-.171-.289-.543.472-.542.324 0 1.955.126 2.919.293h-.001Z",
  fill: "#0C2635"
})), /*#__PURE__*/React.createElement("mask", {
  id: "bA",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 191,
  y: 138,
  width: 6,
  height: 6
}, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
  d: "M196.328 138.696c.356.062.555.473.387 1.012-.232.748-.657.858-1.125.799-.469-.059-1.729-.283-1.891-.075-.059.075-.369.919-.887 1.581-.189.241-1.03 1.126-1.156 1.196-.127.07-.428.093-.555 0-.127-.093 0-1.382.844-2.717.843-1.335.958-1.376.993-1.547.035-.171-.289-.543.472-.542.324 0 1.955.126 2.919.293h-.001Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#bA)"
}, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
  d: "M192.849 138.979s.326.076.485-.034c.159-.109.558-.082 1.021-.055.458.026 2.567.219 2.567.219s-.334-.663-.45-.707c-.118-.043-3.66-.151-3.66-.151v.244l.037.484Z",
  fill: "#BBBDBF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M196.975 139.834s-2.495-.27-3.018-.18c-.523.091-.749.356-.893.56-.346.494-1.409 2.682-1.467 2.775-.058.092.256.348.256.348l2.262-2.705 1.527.036s.847.011.959-.175c.112-.186.374-.659.374-.659Z",
  fill: "#0C1B24",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.5
}), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M193.25 138.287s-.208.186.312.302c.519.116 3.293.357 3.293.357s-.317-.415-.679-.439c-.363-.023-2.926-.22-2.926-.22Z",
  fill: "#fff"
})), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M193.331 139.081c-.011.077-.182.115-.379.084-.198-.03-.349-.118-.338-.194.012-.077.182-.115.38-.084.198.03.349.117.337.194Z",
  fill: "#0C1B24"
})), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M192.463 139.621c.227-.262.555-.325.451-.058-.104.267-1.303 3.076-1.533 3.332-.094.106-.55.049-.519-.087.152-.67.862-2.398 1.105-2.728.242-.331.496-.459.496-.459Z",
  fill: "#fff"
}))), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
  d: "M192.653 139.189c.056-.12.158-.191.227-.158l.163.077c.07.032.081.156.025.276-.056.119-.158.19-.227.157l-.164-.077c-.069-.032-.08-.156-.024-.276v.001Z",
  fill: "#29FF73"
})), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
  d: "m192.841 139.542-.164-.077c.07.032.171-.038.227-.158.056-.12.045-.243-.024-.276l.163.077c.07.032.081.156.025.276-.056.12-.158.19-.227.158Z",
  fill: "#0C1B24",
  opacity: 0.1
})), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
  d: "M191.049 143.777c-.186-.087-.315-.229-.288-.317v-.001l.273-.892c.027-.088.268-.058.538.068.27.127.45.292.4.37l-.496.788c-.05.078-.24.071-.427-.016Z",
  fill: "#1D3439"
})), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
  d: "m191.972 143.005-.496.789c.049-.078-.081-.22-.289-.318-.208-.097-.399-.104-.426-.016l.273-.893c.027-.088.268-.058.538.068.27.127.45.292.4.37Z",
  fill: "#0C1B24",
  opacity: 0.2
}))), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
  d: "M172.166 133.766c1.332 24.982-10.65 28.636 7.65 28.023 12-.403 9.171-15.926 12-19.354",
  stroke: "#231F20",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 230.625,
  y1: 77.556,
  x2: 231.288,
  y2: 76.101,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#505B64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#4D5861"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#454F57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#384047"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#252C31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A1F23"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 238.163,
  y1: 83.75,
  x2: 238.604,
  y2: 82.781,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#505B64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#4D5861"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#454F57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#384047"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#252C31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A1F23"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "m",
  x1: 223.986,
  y1: 168.747,
  x2: 221.422,
  y2: 161.536,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "n",
  x1: 194.456,
  y1: 147.256,
  x2: 194.146,
  y2: 145.041,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3B3B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#D3D3D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#E6E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#DCDCDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#C2C2C2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#999"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "o",
  x1: 246.337,
  y1: 146.719,
  x2: 246.337,
  y2: 144.711,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "p",
  x1: 243.885,
  y1: 151.666,
  x2: 246.547,
  y2: 150.293,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "q",
  x1: 204.26,
  y1: 160.23,
  x2: 204.26,
  y2: 153.698,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#515151"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#777"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#959595"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#ADADAD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#BEBEBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#C8C8C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "r",
  x1: 219.883,
  y1: 162.319,
  x2: 219.883,
  y2: 156.977,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "s",
  x1: 234.146,
  y1: 133.131,
  x2: 238.508,
  y2: 133.131,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#151515"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#767676"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#8F8F8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#999"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#5D5D5D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#2A2A2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#0B0B0B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "t",
  x1: 250.976,
  y1: 168.597,
  x2: 250.976,
  y2: 150.054,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A1A1A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "u",
  x1: 250.975,
  y1: 163.544,
  x2: 250.975,
  y2: 155.075,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87888A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "v",
  x1: 245.607,
  y1: 156.446,
  x2: 249.961,
  y2: 156.446,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "w",
  x1: 247.895,
  y1: 157.764,
  x2: 247.895,
  y2: 155.489,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "x",
  x1: 247.893,
  y1: 157.695,
  x2: 247.893,
  y2: 155.565,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "y",
  x1: 248.44,
  y1: 155.053,
  x2: 248.44,
  y2: 154.377,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "z",
  x1: 248.443,
  y1: 154.888,
  x2: 248.443,
  y2: 154.53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "A",
  x1: 248.443,
  y1: 154.888,
  x2: 248.443,
  y2: 154.671,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "B",
  x1: 246.1,
  y1: 157.834,
  x2: 246.1,
  y2: 157.158,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "C",
  x1: 246.1,
  y1: 157.675,
  x2: 246.1,
  y2: 157.316,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "D",
  x1: 246.1,
  y1: 157.675,
  x2: 246.1,
  y2: 157.458,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "E",
  x1: 250.972,
  y1: 162.257,
  x2: 250.972,
  y2: 156.409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "F",
  x1: 250.972,
  y1: 162.249,
  x2: 250.972,
  y2: 158.722,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "G",
  x1: 256.084,
  y1: 163.82,
  x2: 245.885,
  y2: 154.798,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3B3B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "H",
  x1: 256.225,
  y1: 163.963,
  x2: 245.716,
  y2: 154.665,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#A6A6A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#8A8A8A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#848484"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#939393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#AAA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "I",
  x1: 253.056,
  y1: 167.251,
  x2: 242.857,
  y2: 158.229,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B3B3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "J",
  x1: 259.011,
  y1: 160.522,
  x2: 248.812,
  y2: 151.499,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B3B3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "K",
  x1: 255.973,
  y1: 163.954,
  x2: 245.774,
  y2: 154.932,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#747474"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#AAA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#D1D1D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#E9E9E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "L",
  x1: 256.388,
  y1: 164.105,
  x2: 245.45,
  y2: 154.429,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#A6A6A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#8A8A8A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#848484"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#939393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#AAA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "M",
  x1: 250.901,
  y1: 168.127,
  x2: 250.901,
  y2: 150.276,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "N",
  x1: 198.031,
  y1: 168.601,
  x2: 198.031,
  y2: 150.058,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A1A1A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "O",
  x1: 198.098,
  y1: 168.287,
  x2: 198.098,
  y2: 150.435,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "P",
  x1: 198.031,
  y1: 163.547,
  x2: 198.031,
  y2: 155.079,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87888A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Q",
  x1: 200.957,
  y1: 153.939,
  x2: 200.957,
  y2: 158.283,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "R",
  x1: 199.635,
  y1: 156.222,
  x2: 201.915,
  y2: 156.222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "S",
  x1: 199.706,
  y1: 156.222,
  x2: 201.84,
  y2: 156.222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "T",
  x1: 202.352,
  y1: 156.764,
  x2: 203.029,
  y2: 156.764,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "U",
  x1: 202.697,
  y1: 156.947,
  x2: 202.697,
  y2: 156.588,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "V",
  x1: 202.697,
  y1: 156.947,
  x2: 202.697,
  y2: 156.731,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "W",
  x1: 199.566,
  y1: 154.43,
  x2: 200.244,
  y2: 154.43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "X",
  x1: 199.904,
  y1: 154.61,
  x2: 199.904,
  y2: 154.251,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Y",
  x1: 199.904,
  y1: 154.61,
  x2: 199.904,
  y2: 154.394,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Z",
  x1: 198.032,
  y1: 162.252,
  x2: 198.032,
  y2: 156.405,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aa",
  x1: 198.034,
  y1: 162.253,
  x2: 198.034,
  y2: 158.726,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#737373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D4D4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ab",
  x1: 198.036,
  y1: 166.135,
  x2: 198.036,
  y2: 152.537,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3B3B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ac",
  x1: 198.049,
  y1: 166.335,
  x2: 198.049,
  y2: 152.323,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#A6A6A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#8A8A8A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#848484"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#939393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#AAA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ad",
  x1: 202.615,
  y1: 166.142,
  x2: 202.615,
  y2: 152.544,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B3B3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ae",
  x1: 193.619,
  y1: 166.142,
  x2: 193.619,
  y2: 152.544,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B3B3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "af",
  x1: 198.21,
  y1: 166.142,
  x2: 198.21,
  y2: 152.544,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#747474"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#AAA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#D1D1D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#E9E9E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ag",
  x1: 198.048,
  y1: 166.551,
  x2: 198.048,
  y2: 151.968,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#A6A6A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#8A8A8A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#848484"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#939393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#AAA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ah",
  x1: 248.154,
  y1: 156.239,
  x2: 248.154,
  y2: 149.668,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3B3B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "silver"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#E2E2E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ai",
  x1: 246.384,
  y1: 156.239,
  x2: 246.384,
  y2: 149.707,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3B3B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#C3C3C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#DCDCDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#ECECEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aj",
  x1: 214.485,
  y1: 160.43,
  x2: 223.78,
  y2: 136.157,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#DFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#E8E8E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#CECECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ak",
  x1: 223.281,
  y1: 165.842,
  x2: 210.227,
  y2: 136.451,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#DFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#E8E8E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#CECECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "al",
  x1: 236.328,
  y1: 144.972,
  x2: 236.328,
  y2: 131.718,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#4B4B4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#383838"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#272727"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#111"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "am",
  x1: 237.921,
  y1: 138.053,
  x2: 247.06,
  y2: 138.053,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#D9D9D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "an",
  x1: 242.739,
  y1: 143.851,
  x2: 247.071,
  y2: 143.851,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2F2F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ao",
  x1: 244.957,
  y1: 144.28,
  x2: 247.168,
  y2: 144.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ap",
  x1: 242.044,
  y1: 143.765,
  x2: 246.452,
  y2: 143.765,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aq",
  x1: 243.406,
  y1: 143.376,
  x2: 245.573,
  y2: 143.376,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FABE78"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ar",
  x1: 227.632,
  y1: 143.246,
  x2: 245.395,
  y2: 143.246,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "as",
  x1: 244.898,
  y1: 145.927,
  x2: 244.898,
  y2: 141.769,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3B3B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "at",
  x1: 208.342,
  y1: 144.85,
  x2: 244.645,
  y2: 144.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#DFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#E8E8E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#CECECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "au",
  x1: 237.786,
  y1: 148.133,
  x2: 237.786,
  y2: 130.181,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#D9D9D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "av",
  x1: 206.787,
  y1: 144.769,
  x2: 221.761,
  y2: 144.769,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#999"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aw",
  x1: 208.271,
  y1: 143.43,
  x2: 209.403,
  y2: 138.094,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#DFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#F2F2F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#E8E8E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#CECECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ax",
  x1: 197.068,
  y1: 140.255,
  x2: 209.157,
  y2: 140.255,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#671120"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#63111F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#58121F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#45131D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#2B151C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A171B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ay",
  x1: 232.017,
  y1: 125.829,
  x2: 236.392,
  y2: 123.497,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#020202"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#090909"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#171717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#292929"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#424242"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#5F5F5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#040404"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "az",
  x1: 237.522,
  y1: 131.446,
  x2: 235.151,
  y2: 124.543,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#040404"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#181818"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#272727"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#303030"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#1F1F1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aA",
  x1: 236.003,
  y1: 127.774,
  x2: 236.003,
  y2: 123.767,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#2B2B2B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#555"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aB",
  x1: 210.179,
  y1: 146.852,
  x2: 210.179,
  y2: 135.763,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.31
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aC",
  x1: 209.47,
  y1: 138.832,
  x2: 209.47,
  y2: 135.762,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#4C4C4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#8E8E8E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#999"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aD",
  x1: 210.522,
  y1: 135.763,
  x2: 209.655,
  y2: 142.954,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#4F4F4F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#464646"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2F2F2F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#171717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#080808"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#030303"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aE",
  x1: 232.525,
  y1: 123.293,
  x2: 236.48,
  y2: 123.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#010101"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#080808"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#141414"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#292929"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#3C3C3C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#535353"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#616161"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aF",
  x1: 232.733,
  y1: 119.633,
  x2: 236.771,
  y2: 119.633,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aG",
  x1: 232.73,
  y1: 119.985,
  x2: 236.774,
  y2: 119.985,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aH",
  x1: 234.867,
  y1: 128.283,
  x2: 234.867,
  y2: 125.915,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#060606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#282828"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#434343"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#565656"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#626262"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aI",
  x1: 234.65,
  y1: 128.301,
  x2: 234.65,
  y2: 125.921,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aJ",
  x1: 234.246,
  y1: 127.828,
  x2: 234.246,
  y2: 126.371,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aK",
  x1: 234.194,
  y1: 127.829,
  x2: 234.194,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aL",
  x1: 234.244,
  y1: 127.829,
  x2: 234.244,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aM",
  x1: 234.219,
  y1: 127.829,
  x2: 234.219,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aN",
  x1: 234.234,
  y1: 127.829,
  x2: 234.234,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aO",
  x1: 234.235,
  y1: 127.83,
  x2: 234.235,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aP",
  x1: 234.119,
  y1: 127.829,
  x2: 234.119,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aQ",
  x1: 234.048,
  y1: 127.829,
  x2: 234.048,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aR",
  x1: 234.22,
  y1: 127.829,
  x2: 234.22,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aS",
  x1: 234.165,
  y1: 127.829,
  x2: 234.165,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aT",
  x1: 234.198,
  y1: 127.829,
  x2: 234.198,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aU",
  x1: 234.243,
  y1: 127.829,
  x2: 234.243,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aV",
  x1: 234.159,
  y1: 127.83,
  x2: 234.159,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aW",
  x1: 234.111,
  y1: 127.829,
  x2: 234.111,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aX",
  x1: 234.033,
  y1: 127.829,
  x2: 234.033,
  y2: 126.371,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aY",
  x1: 234.013,
  y1: 127.829,
  x2: 234.013,
  y2: 127.778,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aZ",
  x1: 234.099,
  y1: 127.747,
  x2: 234.099,
  y2: 127.682,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ba",
  x1: 234.151,
  y1: 127.651,
  x2: 234.151,
  y2: 127.587,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bb",
  x1: 234.188,
  y1: 127.555,
  x2: 234.188,
  y2: 127.491,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bc",
  x1: 234.214,
  y1: 127.46,
  x2: 234.214,
  y2: 127.396,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bd",
  x1: 234.231,
  y1: 127.364,
  x2: 234.231,
  y2: 127.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "be",
  x1: 234.242,
  y1: 127.268,
  x2: 234.242,
  y2: 127.205,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bf",
  x1: 234.246,
  y1: 127.173,
  x2: 234.246,
  y2: 127.109,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg",
  x1: 234.245,
  y1: 127.078,
  x2: 234.245,
  y2: 127.013,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bh",
  x1: 234.241,
  y1: 126.982,
  x2: 234.241,
  y2: 126.917,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bi",
  x1: 234.23,
  y1: 126.886,
  x2: 234.23,
  y2: 126.822,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bj",
  x1: 234.211,
  y1: 126.79,
  x2: 234.211,
  y2: 126.727,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bk",
  x1: 234.184,
  y1: 126.695,
  x2: 234.184,
  y2: 126.631,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bl",
  x1: 234.145,
  y1: 126.599,
  x2: 234.145,
  y2: 126.536,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bm",
  x1: 234.089,
  y1: 126.504,
  x2: 234.089,
  y2: 126.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bn",
  x1: 233.996,
  y1: 126.408,
  x2: 233.996,
  y2: 126.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bo",
  x1: 233.266,
  y1: 127.833,
  x2: 233.266,
  y2: 126.377,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#030303"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#0F0F0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#232323"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#3F3F3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#626262"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bp",
  x1: 235.566,
  y1: 127.34,
  x2: 235.566,
  y2: 126.765,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#999"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bq",
  x1: 234.818,
  y1: 127.066,
  x2: 235.404,
  y2: 127.066,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#383838"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#6C6C6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#8C8C8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#999"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "br",
  x1: 235.11,
  y1: 127.358,
  x2: 235.11,
  y2: 126.929,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#999"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#8C8C8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#6C6C6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#383838"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bs",
  x1: 233.169,
  y1: 127.763,
  x2: 233.169,
  y2: 126.455,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bt",
  x1: 215.047,
  y1: 157.263,
  x2: 215.648,
  y2: 158.227,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#575757"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#373737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#1F1F1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#0D0D0D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#030303"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bu",
  x1: 215.119,
  y1: 157.371,
  x2: 215.569,
  y2: 158.094,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bv",
  x1: 215.345,
  y1: 158.159,
  x2: 215.345,
  y2: 157.682,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bw",
  x1: 197.635,
  y1: 141.434,
  x2: 198.289,
  y2: 139.845,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bx",
  x1: 200.266,
  y1: 142.126,
  x2: 200.266,
  y2: 141.073,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#525252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#343434"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#1D1D1D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#0C0C0C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#030303"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "by",
  x1: 200.04,
  y1: 141.238,
  x2: 200.49,
  y2: 141.961,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bz",
  x1: 200.265,
  y1: 142.025,
  x2: 200.265,
  y2: 141.549,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#5B5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#191919"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "l"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(188.736 118.242)",
  d: "M0 0h71.534v50.402H0z"
})))));
export default SvgEmptyRecord;